export const fr = {
  // Navigation
  navigation: {
    lessons: 'Mes Leçons',
    lessonLibrary: 'Bibliothèque de Leçons',
    tracking: 'Suivi',
    settings: 'Paramètres',
    dashboard: 'Tableau de bord',
    createLesson: 'Créer une leçon',
    editLesson: 'Modifier la leçon',
    back: 'Retour',
    home: 'Accueil',
    schedule: 'Planning',
    analytics: 'Analyses',
    more: 'Plus',
    admin: 'Admin',
    students: 'Élèves'
  },

  // Language
  language: {
    selectLanguage: 'Sélectionner la langue',
    french: 'Français',
    english: 'Anglais'
  },

  // Common actions
  actions: {
    save: 'Enregistrer',
    cancel: 'Annuler',
    delete: 'Supprimer',
    edit: 'Modifier',
    add: 'Ajouter',
    remove: 'Retirer',
    start: 'Commencer',
    stop: 'Arrêter',
    pause: 'Pause',
    resume: 'Reprendre',
    complete: 'Terminer',
    close: 'Fermer',
    next: 'Suivant',
    previous: 'Précédent',
    refresh: 'Actualiser',
    filter: 'Filtrer',
    search: 'Rechercher',
    select: 'Sélectionner',
    create: 'Créer',
    update: 'Mettre à jour',
    loading: 'Chargement...',
    saving: 'Enregistrement...',
    error: 'Erreur',
    success: 'Succès',
    warning: 'Avertissement',
    info: 'Information'
  },

  // Lesson metadata
  lesson: {
    title: 'Titre de la leçon',
    subject: 'Matière',
    domain: 'Discipline',
    construct: 'Compétences',
    subconstruct: 'Titre de la séance',
    selectDomain: 'Sélectionnez la discipline',
    enterConstruct: 'Entrez des compétences',
    enterSubconstruct: 'Entrez le titre de la séance',
    globalMinimumProficiency: 'Maîtrise globale minimale',
    globalMinimumProficiencyPlaceholder: 'Entrez la maîtrise globale minimale (ex: 3)',
    grade: 'Niveau d\'étude',
    duration: 'Durée',
    objectives: 'Objectifs spécifiques',
    prerequisites: 'Prérequis',
    materials: 'Matériaux',
    timeline: 'Chronologie',
    assessments: 'Évaluations',
    resources: 'Ressources',
    createNew: 'Créer une nouvelle leçon',
    editLesson: 'Modifier la leçon',
    lessonInformation: 'Informations de la leçon',
    enterLessonTitle: 'Entrez le titre de la leçon',
    selectSubject: 'Sélectionnez une matière',
    className: 'Nom de la Classe',
    enterClassName: 'Entrer le nom de la classe (ex: Math 101, Salle 205)',
    selectGrade: 'Sélectionnez le niveau d\'étude',
    enterDuration: 'Entrez la durée en minutes',
    addObjective: 'Ajouter un objectif spécifique',
    addPrerequisite: 'Ajouter un prérequis',
    addMaterial: 'Ajouter un matériau',
    addResource: 'Ajouter une ressource',
    addAssessment: 'Ajouter une évaluation',
    addTimelineStep: 'Ajouter une étape',
    saveLesson: 'Enregistrer la leçon',
    lessonSaved: 'Leçon enregistrée avec succès',
    lessonDeleted: 'Leçon supprimée avec succès',
    lessonNotFound: 'Leçon non trouvée',
    loadingLesson: 'Chargement de la leçon...',
    noLessons: 'Aucune leçon trouvée',
    createFirstLesson: 'Créer votre première leçon',
    prerequisitesPlaceholder: 'Que doivent savoir les élèves avant cette leçon ?',
    adminSettings: 'Paramètres d\'administrateur',
    markAsAdminLesson: 'Marquer comme leçon d\'administrateur',
    adminLessonDescription: 'Les leçons d\'administrateur sont disponibles pour tous les enseignants dans la bibliothèque de leçons et peuvent être liées à leurs comptes.',
    importLessons: 'Importer des Leçons',
    uploadExcelFile: 'Télécharger un Fichier Excel',
    excelFileDescription: 'Téléchargez un fichier Excel pour importer plusieurs leçons à la fois',
    importingLessons: 'Importation des leçons...',
    importedSuccessfully: 'Importation réussie de {count} leçons',
    minutes: 'minutes'
  },

  // Subjects
  subjects: {
    all: 'Toutes',
    subject: 'Matière',
    math: 'Mathématiques',
    geometry: 'Géométrie',
    algebra: 'Algèbre',
    preNumericalActivities: 'Activités pré-numériques',
    measurement: 'Mesure',
    topology: 'Topologie',
    numeration: 'Numération',
    operations: 'Opérations',
    language: 'Langage',
    reading: 'Lecture',
    writing: 'Écriture',
    science: 'Sciences',
    english: 'Anglais',
    history: 'Histoire',
    art: 'Art',
    music: 'Musique',
    french: 'Français',
    geography: 'Géographie',
    physicalEducation: 'Éducation physique',
    nationalLanguages: 'Langues nationales',
    other: 'Autre'
  },

  // Grades
  grades: {
    k: 'Maternelle',
    '1': '1ère année',
    '2': '2ème année',
    '3': '3ème année',
    '4': '4ème année',
    '5': '5ème année',
    '6': '6ème année',
    '7': '7ème année',
    '8': '8ème année',
    '9': '9ème année',
    '10': '10ème année',
    '11': '11ème année',
    '12': '12ème année'
  },

  domains: {
    mathematics: 'Mathématiques',
    french: 'Français',
    nationalLanguagesMathematics: 'Langues nationales Mathématiques',
    nationalLanguagesReadingWriting: 'Langues nationales Lecture-Écriture'
  },

  // Resource types
  resources: {
    numberLine: 'Ligne numérique',
    tenFrame: 'Cadre de dix',
    countObjects: 'Compter les objets',
    matchingObjects: 'Associer les objets',
    timer: 'Minuteur',
    quiz: 'Quiz rapide',
    interactiveDiagram: 'Diagramme interactif',
    simulation: 'Simulation',
    flashcardSet: 'Jeu de cartes mémoire',
    gridActivity: 'Activité de grille',
    audioBank: 'Banque audio',
    assessment: 'Évaluation',
    activity: 'Activité',
    feedback: 'Retour',
    display: 'Affichage',
    manipulative: 'Manipulatif'
  },

  // Resource configuration
  resourceConfig: {
    // Number Line
    minimumValue: 'Valeur minimale',
    maximumValue: 'Valeur maximale',
    tickEvery: 'Graduation tous les',
    step: 'Étape',
    theme: 'Thème',
    primary: 'Primaire',
    secondary: 'Secondaire',
    showLabels: 'Afficher les Labels',
    showNumberLabels: 'Afficher les labels de nombres',
    showTicks: 'Afficher les Graduations',
    showTickMarks: 'Afficher les marques de graduation',
    interactive: 'Interactif',
    allowUserInteraction: 'Permettre l\'interaction utilisateur',
    highestNumberToInclude: 'Plus grand nombre à inclure dans l\'association',

    // Ten Frame
    rows: 'Lignes',
    columns: 'Colonnes',
    doubleFrame: 'Double cadre',
    showTwoFrames: 'Afficher deux cadres',
    dragCounters: 'Glisser les compteurs',
    allowDraggingCounters: 'Permettre de glisser les compteurs',

    // Count Objects
    maxObjects: 'Objets maximum',
    randomizeObjects: 'Randomiser les objets',
    randomizeObjectPositions: 'Randomiser les positions des objets',
    touchFeedback: 'Retour tactile',
    ping: 'Ping',
    pulse: 'Pulsation',
    bounce: 'Rebond',
    shake: 'Secousse',
    none: 'Aucun',
    objectGroups: 'Groupes d\'Objets',
    objectGroup: 'Groupe d\'Objets',
    objectType: 'Type d\'Objet',
    objectCount: 'Nombre d\'Objets',
    objectColor: 'Couleur d\'Objet',
    circle: 'Cercle',
    square: 'Carré',
    triangle: 'Triangle',
    star: 'Étoile',
    blue: 'Bleu',
    red: 'Rouge',
    green: 'Vert',
    yellow: 'Jaune',
    purple: 'Violet',
    orange: 'Orange',
    addObjectGroup: 'Ajouter un Groupe d\'Objets',
    question: 'Question',
    questionPlaceholder: 'Entrez une question pour les élèves...',
    showCount: 'Afficher le Compteur',
    showObjectCount: 'Afficher le nombre d\'objets',
    allowInteraction: 'Permettre l\'Interaction',
    allowObjectInteraction: 'Permettre l\'interaction avec les objets',

    // Matching Objects
    numberOfItems: 'Nombre d\'éléments',
    howManyUniqueNumbers: 'Combien de nombres uniques à associer',
    representationTypes: 'Types de représentation',
    includeObjects: 'Inclure les objets',
    includeNumerals: 'Inclure les chiffres',
    includeTenFrames: 'Inclure les cadres de dix',
    includeNumberWords: 'Inclure les mots-nombres',
    selectAtLeastTwo: 'Sélectionnez au moins 2 types de représentation',
    objectLayout: 'Disposition des objets',
    howObjectsAreArranged: 'Comment les objets sont disposés visuellement',
    randomClustered: 'Regroupement aléatoire',
    linear: 'Linéaire',
    twoGroups: 'Deux groupes',
    circular: 'Circulaire',
    preview: 'Aperçu',
    matchingActivityWith: 'Activité d\'association avec',
    uniqueNumbersUpTo: 'nombres uniques jusqu\'à',
    includes: 'Inclut',
    noRepresentationsSelected: 'Aucune représentation sélectionnée',

    // Timer
    duration: 'Durée',
    durationSeconds: 'Durée (secondes)',
    autoLaunch: 'Lancement automatique',
    startTimerAutomatically: 'Démarrer le minuteur automatiquement',

    // Flashcard Set
    flashcards: 'Cartes mémoire',
    front: 'Recto',
    back: 'Verso',
    answer: 'Réponse',
    card: 'Carte',
    addCard: 'Ajouter une carte',
    autoFlip: 'Retournement Auto',
    autoFlipCards: 'Retourner automatiquement les cartes',
    showProgress: 'Afficher le Progrès',
    showCardProgress: 'Afficher le progrès des cartes',
    autoAdvance: 'Avance automatique',
    autoAdvanceSeconds: 'Avance automatique (secondes)',
    autoAdvanceSecondsDescription: 'Secondes entre les avances automatiques',
    shuffle: 'Mélanger',
    shuffleCards: 'Mélanger les cartes',
    quickSetup: 'Configuration rapide',
    numbers0To10NumeralToWord: 'Nombres 0-10 (Chiffre → Mot)',
    numbers0To10WordToNumeral: 'Nombres 0-10 (Mot → Chiffre)',

    // Grid Activity
    bank: 'Banque',
    bankCommaSeparated: 'Banque (séparée par des virgules)',
    mode: 'Mode',
    readAndSelect: 'Lire et sélectionner',
    matchPairs: 'Associer les paires',
    fillBlanks: 'Remplir les blancs',

    // Audio Bank
    words: 'Mots',
    wordsCommaSeparated: 'Mots (séparés par des virgules)',
    autoPlay: 'Lecture automatique',
    playAudioAutomatically: 'Lire l\'audio automatiquement',
    loop: 'Boucle',
    loopAudio: 'Boucler l\'audio',

    // Simulation
    simulationTitle: 'Titre de la simulation',
    virtualLabSimulation: 'Simulation de laboratoire virtuel',
    enterSimulationTitle: 'Entrez le titre de la simulation',
    description: 'Description',
    enterSimulationDescription: 'Entrez la description de la simulation',

    // Interactive Diagram
    diagramTitle: 'Titre du diagramme',
    interactiveDiagram: 'Diagramme interactif',
    enterDiagramTitle: 'Entrez le titre du diagramme',
    numberOfStages: 'Nombre d\'étapes',
    stage: 'Étape',
    stageDescription: 'Description de l\'étape',
    detailedInformationAboutStage: 'Informations détaillées sur l\'étape',

    // Additional keys for BasicResourceConfigurationForm
    numberLineFrom: 'Ligne numérique de',
    to: 'à',
    withTicksEvery: 'avec des graduations tous les',
    unit: 'unité',
    interactiveDisplay: 'interactif',
    displayOnly: 'affichage seulement',
    noConfigurationOptions: 'Aucune option de configuration disponible pour ce type de ressource.',
    remove: 'Supprimer',

    // Time Sequence
    timeSequence: 'Séquence Temporelle',
    events: 'Événements',
    event: 'Événement',
    time: 'Heure',
    activity: 'Activité',
    period: 'Période',
    morning: 'Matin',
    afternoon: 'Après-midi',
    evening: 'Soir',
    night: 'Nuit',
    addEvent: 'Ajouter un Événement',
    removeEvent: 'Supprimer l\'Événement',
    showTime: 'Afficher l\'Heure',
    showPeriod: 'Afficher la Période',
    allowReordering: 'Permettre le Réordonnancement',
    dragToReorder: 'Glisser pour réorganiser les événements',
    sequenceEvents: 'Séquencez les événements dans l\'ordre chronologique',
    timeSequenceInstructions: 'Organisez les activités quotidiennes dans le bon ordre temporel',
    timeSequenceDefaultQuestion: 'Organisez les activités quotidiennes dans l\'ordre chronologique',
    defaultQuestion: 'Organisez les activités quotidiennes dans l\'ordre chronologique',
    wakeUp: 'Se réveiller',
    breakfast: 'Prendre le petit-déjeuner',
    goToSchool: 'Aller à l\'école',
    lunch: 'Déjeuner',
    returnFromSchool: 'Rentrer de l\'école',
    goToBed: 'Se coucher',
    activityTakesPlace: 'Cette activité se déroule',
    inTheMorning: 'le matin',
    inTheAfternoon: 'l\'après-midi',
    inTheEvening: 'le soir',
    atNight: 'la nuit',
    at: 'à',

    // Measurement
    measurement: 'Mesure',
    objects: 'Objets',
    object: 'Objet',
    units: 'Unités',
    length: 'Longueur',
    size: 'Taille',
    shape: 'Forme',
    color: 'Couleur',
    addObject: 'Ajouter un Objet',
    addUnit: 'Ajouter une Unité',
    removeObject: 'Supprimer l\'Objet',
    removeUnit: 'Supprimer l\'Unité',
    objectName: 'Nom de l\'Objet',
    unitName: 'Nom de l\'Unité',
    objectLength: 'Longueur de l\'Objet',
    unitSize: 'Taille de l\'Unité',
    showAnswers: 'Afficher les Réponses',
    measure: 'Mesurer',
    reset: 'Réinitialiser',
    readyToMeasure: 'Prêt à mesurer',
    with: 'avec',
    selectObjectAndUnit: 'Sélectionnez un objet et une unité pour commencer',
    measurementResults: 'Résultats de mesure',
    measurementInstructions: 'Observez les objets et leurs mesures. Comparez les longueurs et identifiez les unités utilisées.',
    measurementDefaultQuestion: 'Mesurez les objets avec les unités appropriées',
    objectMeasurement: 'Mesure d\'Objets',
    measureObjectsWithNonStandardUnits: 'Mesurez les objets avec des unités non-standard',
    objectsToMeasure: 'Objets à mesurer',
    measurementUnits: 'Unités de mesure',
    pencil: 'Crayon',
    eraser: 'Gomme',
    pen: 'Stylo',
    paperclips: 'Trombones',
    cubes: 'Cubes',
    books: 'Livres',

    // Modal
    noConfigOptions: 'Aucune option de configuration disponible pour ce type de ressource.',
    overrideSettings: 'Paramètres de remplacement',
    overrideDescription: 'Ces paramètres remplaceront la configuration par défaut de la ressource pour cette étape uniquement.',
    objectsCount: 'Nombre d\'objets',
    layout: 'Disposition',
    randomize: 'Randomiser',
    minValue: 'Valeur minimale',
    maxValue: 'Valeur maximale',
    cols: 'Colonnes',
    seconds: 'Secondes',
    id: 'ID',

    // Memory Game Configuration
    gameTitle: 'Titre du jeu',
    memoryGame: 'Jeu de mémoire',
    enterGameTitle: 'Entrez le titre du jeu',
    gameDescription: 'Description du jeu',
    enterGameDescription: 'Entrez la description du jeu',
    gameItems: 'Éléments du jeu',
    emoji: 'Emoji',
    word: 'Mot',
    enterWord: 'Entrez le mot',
    addItem: 'Ajouter un élément',
    removeItem: 'Supprimer l\'élément',
    gameSettings: 'Paramètres du jeu',
    autoStartGame: 'Démarrer automatiquement le jeu',
    showHints: 'Afficher les indices',
    soundEffects: 'Effets sonores',
    difficultyLevel: 'Niveau de difficulté',
    easy: 'Facile',
    medium: 'Moyen',
    hard: 'Difficile',

    // Sorting Game Configuration
    categories: 'Catégories',
    categoryName: 'Nom de la catégorie',
    enterCategoryName: 'Entrez le nom de la catégorie',
    addCategory: 'Ajouter une catégorie',
    removeCategory: 'Supprimer la catégorie',
    category: 'Catégorie'
  },

  timeSequence: {
    description: 'Description',
    tip: 'Astuce',
    tipDescription: 'Vous pouvez faire glisser les activités pour les réorganiser dans l\'ordre chronologique.',
    defaultQuestion: 'Organisez les activités quotidiennes dans l\'ordre chronologique',
    wakeUp: 'Se réveiller',
    breakfast: 'Prendre le petit-déjeuner',
    goToSchool: 'Aller à l\'école',
    lunch: 'Déjeuner',
    returnFromSchool: 'Rentrer de l\'école',
    goToBed: 'Se coucher',
    activityTakesPlace: 'Cette activité se déroule',
    inTheMorning: 'le matin',
    inTheAfternoon: 'l\'après-midi',
    inTheEvening: 'le soir',
    atNight: 'la nuit',
    at: 'à',
    morning: 'Matin',
    afternoon: 'Après-midi',
    evening: 'Soir',
    night: 'Nuit',
    monday: 'Lundi',
    tuesday: 'Mardi',
    wednesday: 'Mercredi',
    thursday: 'Jeudi',
    friday: 'Vendredi',
    saturday: 'Samedi',
    sunday: 'Dimanche',
  },

  measurement: {
    defaultQuestion: 'Mesurez les objets avec les unités appropriées',
    objectMeasurement: 'Mesure d\'Objets',
    measureObjectsWithNonStandardUnits: 'Mesurez les objets avec des unités non-standard',
    objectsToMeasure: 'Objets à mesurer',
    measurementUnits: 'Unités de mesure',
    pencil: 'Crayon',
    eraser: 'Gomme',
    pen: 'Stylo',
    paperclips: 'Trombones',
    cubes: 'Cubes',
    books: 'Livres',
    measurementResults: 'Résultats de mesure',
    selectObjectAndUnit: 'Sélectionnez un objet et une unité pour commencer',
    length: 'Longueur',
    size: 'Taille',
    shape: 'Forme',
    color: 'Couleur',
    showAnswers: 'Afficher les Réponses',
    measure: 'Mesurer',
    reset: 'Réinitialiser',
    readyToMeasure: 'Prêt à mesurer',
    with: 'avec',
    unit: 'Unité',
    correct: 'Correct',
    incorrect: 'Incorrect',
    actualLength: 'Longueur Réelle',
    measurement: 'Mesure',
    expected: 'Attendu',
    status: 'Statut',
    tip: 'Astuce',
    measurementTip: 'Comparez vos mesures avec les valeurs attendues pour vérifier votre compréhension.',
  },

  currency: {
    defaultQuestion: 'Créez le montant cible en utilisant les unités de monnaie disponibles',
    currencyCombination: 'Combinaison de Monnaie',
    createAmountWithCurrency: 'Créez des montants en utilisant différentes unités de monnaie',
    targetAmount: 'Montant Cible',
    useCurrencyUnits: 'Utilisez les unités de monnaie pour atteindre la cible',
    availableUnits: 'Unités Disponibles',
    currentTotal: 'Total Actuel',
    checkAnswer: 'Vérifier la Réponse',
    reset: 'Réinitialiser',
    correct: 'Correct !',
    incorrect: 'Incorrect',
    correctMessage: 'Parfait ! Vous avez créé exactement {amount}',
    incorrectMessage: 'Votre total est {current}, mais la cible est {target}',
    yourCombination: 'Votre Combinaison',
    instructions: 'Instructions',
    instructionsDescription: 'Cliquez sur les unités de monnaie pour les ajouter à votre combinaison. Utilisez les boutons + et - pour ajuster les quantités.',
    coin1: 'Pièce de 1€',
    coin2: 'Pièce de 2€',
    bill5: 'Billet de 5€',
    bill10: 'Billet de 10€',
    newTarget: 'Nouvelle Cible',
    question: 'Question',
    questionPlaceholder: 'Entrez une question pour les élèves...',
    showTarget: 'Afficher le Montant Cible',
    allowInteraction: 'Permettre l\'Interaction',
    theme: 'Thème',
    primary: 'Primaire',
    secondary: 'Secondaire',
    success: 'Succès',
    warning: 'Avertissement',
    newUnit: 'Nouvelle Unité',
    currencyUnits: 'Unités de Monnaie',
    unit: 'Unité',
    name: 'Nom',
    value: 'Valeur',
    symbol: 'Symbole',
    icon: 'Icône',
    color: 'Couleur',
    displayOptions: 'Options d\'Affichage',
    changeTarget: 'Changer le Montant Cible',
    minTarget: 'Montant Cible Minimum',
    maxTarget: 'Montant Cible Maximum',
    coins: 'Pièces',
    bills: 'Billets',
    euro: 'Euro',
    yellow: 'Jaune',
    green: 'Vert',
    blue: 'Bleu',
    red: 'Rouge',
    purple: 'Violet',
    gray: 'Gris',
    addUnit: 'Ajouter une Unité',
  },

  schedule: {
    scheduleManagement: 'Gestion des horaires',
    manageLessonSchedules: 'Gérer les horaires de cours et les sessions récurrentes',
    calendar: 'Calendrier',
    list: 'Liste',
    createSchedule: 'Créer un horaire',
    editSchedule: 'Modifier l\'horaire',
    scheduleDetails: 'Détails de l\'horaire',
    week: 'Semaine',
    month: 'Mois',
    today: 'Aujourd\'hui',
    untitled: 'Sans titre',
    more: 'plus',
    start: 'Commencer',
    complete: 'Terminer',
    edit: 'Modifier',
    delete: 'Supprimer',
    cancel: 'Annuler',
    save: 'Enregistrer',
    saving: 'Enregistrement...',
    update: 'Mettre à jour',
    export: 'Exporter',
    refresh: 'Actualiser',
    searchSchedules: 'Rechercher des horaires...',
    allSchedules: 'Tous les horaires',
    activeSchedules: 'Horaires actifs',
    inactiveSchedules: 'Horaires inactifs',
    scheduleList: 'Liste des horaires',
    loading: 'Chargement...',
    noSchedulesFound: 'Aucun horaire trouvé',
    noSchedulesCreated: 'Aucun horaire créé',
    confirmDelete: 'Êtes-vous sûr de vouloir supprimer cet horaire ?',
    title: 'Titre',
    enterTitle: 'Entrer le titre de l\'horaire',
    lesson: 'Leçon',
    selectLesson: 'Sélectionner une leçon',
    searchLessons: 'Rechercher des leçons...',
    noLessonsFound: 'Aucune leçon trouvée correspondant à votre recherche',
    untitledLesson: 'Leçon sans titre',
    class: 'Classe',
    selectClass: 'Sélectionner une classe',
    createNewClass: 'Créer une nouvelle classe',
    enterClassName: 'Entrer le nom de la classe (ex: Math 101, Salle 205)',
    className: 'Nom de la classe',
    grade: 'Niveau d\'étude',
    selectGrade: 'Sélectionner le niveau d\'étude',
    enterClassDescription: 'Entrer la description de la classe',
    description: 'Description',
    enterDescription: 'Entrer la description de l\'horaire',
    startDate: 'Date de début',
    startTime: 'Heure de début',
    duration: 'Durée',
    endDate: 'Date de fin',
    optional: 'Optionnel',
    recurrenceTitle: 'Récurrence',
    recurrenceType: 'Type de récurrence',
    noRecurrence: 'Aucune récurrence',
    daily: 'Quotidien',
    weekly: 'Hebdomadaire',
    monthly: 'Mensuel',
    interval: 'Intervalle',
    daysOfWeek: 'Jours de la semaine',
    dayOfMonth: 'Jour du mois',
    endAfterOccurrences: 'Terminer après occurrences',
    enterOccurrences: 'Entrer le nombre d\'occurrences',
    endAfterOccurrencesHelp: 'Laisser vide pour continuer indéfiniment ou jusqu\'à la date de fin',
    maxStudents: 'Nombre max d\'élèves',
    location: 'Lieu',
    enterLocation: 'Entrer le lieu',
    notes: 'Notes',
    enterNotes: 'Entrer des notes',
    conflictsDetected: 'Conflits détectés',
    unknownLesson: 'Leçon inconnue',
    sunday: 'Dim',
    monday: 'Lun',
    tuesday: 'Mar',
    wednesday: 'Mer',
    thursday: 'Jeu',
    friday: 'Ven',
    saturday: 'Sam',
    status: {
      scheduled: 'Programmé',
      in_progress: 'En cours',
      completed: 'Terminé',
      cancelled: 'Annulé'
    },
    recurrence: {
      none: 'Aucune récurrence',
      daily: 'Quotidien',
      weekly: 'Hebdomadaire',
      monthly: 'Mensuel'
    },
    active: 'Actif',
    inactive: 'Inactif',
    noDescription: 'Aucune description',
    create: 'Créer',
    grade1: '1ère année',
    grade2: '2ème année',
    grade3: '3ème année',
    import: 'Importer',
    importing: 'Importation...',
    importSuccess: '{count} horaires importés avec succès',
    importError: 'Erreur lors de l\'importation des horaires. Veuillez vérifier le format du fichier.',
    importPreview: 'Aperçu de l\'importation',
    importPreviewDescription: 'Vérifiez {valid} horaires valides et {invalid} horaires invalides avant l\'importation',
    validSchedules: 'Horaires Valides',
    invalidSchedules: 'Horaires Invalides',
    valid: 'Valide',
    invalid: 'Invalide',
    confirmImport: 'Confirmer l\'importation',
    validationError: 'Erreur de validation',
    grade4: '4ème année',
    grade5: '5ème année',
    grade6: '6ème année',
    grade7: '7ème année',
    grade8: '8ème année',
    grade9: '9ème année',
    grade10: '10ème année',
    grade11: '11ème année',
    grade12: '12ème année',
    conflictMessage: 'Conflit avec un horaire existant le {date}'
  },

  // Assessment Panel
  assessmentPanel: {
    // Stimulus Components
    countTheObjects: 'Compter les objets',
    howManyObjectsDoYouSee: 'Combien d\'objets voyez-vous ?',
    layout: 'Disposition',
    tenFrame: 'Cadre de dix',
    fiveFrame: 'Cadre de cinq',
    twentyFrame: 'Cadre de vingt',
    customFrame: 'Cadre',
    howManyDotsInTenFrame: 'Combien de points y a-t-il dans le cadre de dix ?',
    howManyDotsInFiveFrame: 'Combien de points y a-t-il dans le cadre de cinq ?',
    howManyDotsInTwentyFrame: 'Combien de points y a-t-il dans le cadre de vingt ?',
    howManyDotsInCustomFrame: 'Combien de points y a-t-il dans le cadre ?',
    howManyDotsInFrame: 'Combien de points y a-t-il dans le cadre ?',
    frameShowingDots: 'cadre montrant des points',
    numberLine: 'Ligne numérique',
    whatNumberIsMarked: 'Quel nombre est marqué sur la ligne numérique ?',
    numberSequence: 'Séquence numérique',
    chooseCorrectNumber: 'Choisissez le bon nombre',
    whatNumberComesBefore: 'Quel nombre vient avant ?',
    whatNumberComesAfter: 'Quel nombre vient après ?',
    whatNumberComesBetween: 'Quel nombre vient entre ?',
    numberComposition: 'Composition de nombres',
    writeNumberThatMatches: 'Écrivez le nombre qui correspond à la description',
    whatComesNextInSequence: 'Que vient ensuite dans la séquence ?',
    patternRecognition: 'Reconnaissance de motifs',
    findPatternAndSelect: 'Trouvez le motif et sélectionnez la pièce manquante',
    numberComparison: 'Comparaison de nombres',
    compareNumbersAndSelect: 'Comparez les nombres et sélectionnez la bonne réponse',
    resourceComponentNotImplemented: 'Composant de ressource pas encore implémenté',
    highestNumberToInclude: 'Plus grand nombre à inclure dans l\'activité de correspondance',
    enterYourAnswer: 'Entrez votre réponse :',
    enterNumber: 'Entrez un nombre',
    assessment: 'Évaluation',
    readyToTestKnowledge: 'Prêt à tester vos connaissances ?',
    assessmentDetails: 'Détails de l\'évaluation :',
    totalQuestions: 'Total des questions :',
    pointsPerQuestion: 'Points par question :',
    masteryThreshold: 'Seuil de maîtrise :',
    cancel: 'Annuler',
    startAssessment: 'Commencer l\'évaluation',
    congratulations: 'Félicitations !',
    assessmentComplete: 'Évaluation terminée',
    youHaveMastered: 'Vous avez maîtrisé ce contenu !',
    keepPracticingToImprove: 'Continuez à pratiquer pour améliorer votre score.',
    correctAnswers: 'Réponses correctes',
    score: 'Score',
    timeSpent: 'Temps passé',
    status: 'Statut',
    mastered: 'Maîtrisé',
    inProgress: 'En cours',
    close: 'Fermer',
    previous: 'Précédent',
    next: 'Suivant',
    
    // Missing keys
    question: 'Question',
    questionType: 'Type de question',
    resourceType: 'Type de ressource',
    numberLineFrom: 'Ligne numérique de'
  },

  // Authentication
  auth: {
    appName: 'Application Éducative',
    tagline: 'Donner aux enseignants les outils numériques',
    welcomeBack: 'Bon Retour',
    signInToContinue: 'Connectez-vous pour accéder à votre tableau de bord',
    createAccount: 'Créer un Compte',
    joinOurCommunity: 'Rejoignez notre communauté d\'éducateurs',
    email: 'Email',
    enterEmail: 'Entrez votre email',
    password: 'Mot de passe',
    enterPassword: 'Entrez votre mot de passe',
    confirmPassword: 'Confirmer le mot de passe',
    fullName: 'Nom Complet',
    enterFullName: 'Entrez votre nom complet',
    school: 'École',
    enterSchool: 'Entrez le nom de votre école',
    subjects: 'Matières',
    grades: 'Niveaux',
    optional: 'Optionnel',
    signIn: 'Se Connecter',
    signUp: 'S\'inscrire',
    signingIn: 'Connexion...',
    creatingAccount: 'Création du compte...',
    dontHaveAccount: 'Vous n\'avez pas de compte ?',
    alreadyHaveAccount: 'Vous avez déjà un compte ?',
    signOut: 'Se Déconnecter',
    profile: 'Profil',
    updateProfile: 'Mettre à jour le profil'
  },

  // Assessment
  assessment: {
    title: 'Évaluation',
    assessmentTitle: 'Titre de l\'évaluation',
    studentAssessment: 'Évaluation de l\'élève',
    enterAssessmentTitle: 'Entrez le titre de l\'évaluation',
    instructions: 'Instructions',
    enterAssessmentInstructions: 'Entrez les instructions d\'évaluation',
    selectAssessmentResource: 'Sélectionner une ressource d\'évaluation',
    selectAnAssessmentResource: 'Sélectionnez une ressource d\'évaluation...',
    timeLimit: 'Limite de temps',
    timeLimitMinutes: 'Limite de temps (minutes)',
    autoStart: 'Démarrage automatique',
    startAssessmentAutomatically: 'Démarrer l\'évaluation automatiquement',
    startAssessment: 'Démarrer l\'évaluation',
    completeAssessment: 'Terminer l\'évaluation',
    resourceType: 'Type de ressource',
    noneSelected: 'Aucune sélection',
    timeRemaining: 'Temps restant',
    minutesRemaining: 'minutes restantes',
    assessmentCompleted: 'Évaluation terminée',
    assessmentInProgress: 'Évaluation en cours',
    noAssessmentResources: 'Aucune ressource d\'évaluation disponible',
    createAssessmentResources: 'Créez d\'abord des ressources compatibles avec les évaluations dans l\'onglet Ressources'
  },

  // Lesson session
  session: {
    totalTime: 'Temps total',
    stepTime: 'Temps d\'étape',
    progress: 'Progression',
    currentStep: 'Étape actuelle',
    nextStep: 'Étape suivante',
    previousStep: 'Étape précédente',
    play: 'Jouer',
    pause: 'Pause',
    stop: 'Arrêter',
    reset: 'Réinitialiser',
    resources: 'Ressources',
    noResourcesAvailable: 'Aucune ressource disponible pour cette étape',
    expandResourcesPanel: 'Développer le panneau des ressources',
    closeResourcesPanel: 'Fermer le panneau des ressources',
    scrollToTop: 'Défiler vers le haut',
    activeSession: 'Session active'
  },

  // Tracking
  tracking: {
    dashboard: 'Tableau de bord de suivi',
    monitorStudentEngagement: 'Surveiller l\'engagement des élèves et les analyses d\'apprentissage',
    filters: 'Filtres',
    refreshData: 'Actualiser les données',
    student: 'Élève',
    lesson: 'Leçon',
    date: 'Date',
    time: 'Heure',
    duration: 'Durée',
    score: 'Score',
    attempts: 'Tentatives',
    completed: 'Terminé',
    incomplete: 'Incomplet',
    allStudents: 'Tous les élèves',
    allLessons: 'Toutes les leçons',
    allDates: 'Toutes les dates',
    lastActivity: 'Dernière activité',
    totalEvents: 'Événements totaux',
    averageScore: 'Score moyen',
    completionRate: 'Taux de completion',
    engagementScore: 'Score d\'engagement',
    timeSpent: 'Temps passé',
    lessonSummary: 'Résumé de la leçon',
    studentProgress: 'Progression de l\'élève',
    eventDetails: 'Détails de l\'événement',
    noDataAvailable: 'Aucune donnée disponible',
    noEventsFound: 'Aucun événement trouvé',
    exportData: 'Exporter les données',
    downloadCSV: 'Télécharger CSV',
    downloadJSON: 'Télécharger JSON'
  },

  // Matching Objects Component
  matchingObjects: {
    title: 'Associer les représentations',
    matchTheRepresentations: 'Associez les représentations',
    generateNewItems: 'Générer de nouveaux éléments',
    allMatchesFound: 'Toutes les associations trouvées',
    attempts: 'Tentatives',
    matches: 'Associations',
    total: 'Total',
    clickAnotherItem: 'Cliquez sur un autre élément pour l\'associer avec celui sélectionné',
    objects: 'Objets',
    numerals: 'Chiffres',
    tenFrames: 'Cadres de dix',
    words: 'Mots',
    numberWords: {
      one: 'un',
      two: 'deux',
      three: 'trois',
      four: 'quatre',
      five: 'cinq',
      six: 'six',
      seven: 'sept',
      eight: 'huit',
      nine: 'neuf',
      ten: 'dix'
    }
  },

  // Form validation
  validation: {
    required: 'Ce champ est requis',
    invalidEmail: 'Adresse e-mail invalide',
    minLength: 'Doit contenir au moins {min} caractères',
    maxLength: 'Ne peut pas dépasser {max} caractères',
    minValue: 'La valeur doit être au moins {min}',
    maxValue: 'La valeur ne peut pas dépasser {max}',
    invalidFormat: 'Format invalide',
    selectAtLeastOne: 'Sélectionnez au moins un élément',
    selectAtLeastTwo: 'Sélectionnez au moins deux éléments',
    validResource: 'une ressource valide'
  },

  // Error messages
  errors: {
    general: 'Une erreur s\'est produite',
    networkError: 'Erreur de réseau',
    serverError: 'Erreur du serveur',
    notFound: 'Non trouvé',
    unauthorized: 'Non autorisé',
    forbidden: 'Interdit',
    validationError: 'Erreur de validation',
    fileUploadError: 'Erreur lors du téléchargement du fichier',
    saveError: 'Erreur lors de l\'enregistrement',
    loadError: 'Erreur lors du chargement',
    deleteError: 'Erreur lors de la suppression',
    importError: 'Erreur lors de l\'importation',
    exportError: 'Erreur lors de l\'exportation',
    resourceNotFound: 'Ressource sélectionnée non trouvée'
  },

  // Success messages
  success: {
    saved: 'Enregistré avec succès',
    deleted: 'Supprimé avec succès',
    created: 'Créé avec succès',
    updated: 'Mis à jour avec succès',
    imported: 'Importé avec succès',
    exported: 'Exporté avec succès',
    uploaded: 'Téléchargé avec succès'
  },

  // Placeholders
  placeholders: {
    enterTitle: 'Entrez le titre',
    enterDescription: 'Entrez la description',
    enterName: 'Entrez le nom',
    enterValue: 'Entrez la valeur',
    selectOption: 'Sélectionnez une option',
    searchHere: 'Recherchez ici',
    noResults: 'Aucun résultat',
    loading: 'Chargement...',
    saving: 'Enregistrement...',
    processing: 'Traitement...'
  },

  // Time formatting
  time: {
    seconds: 'secondes',
    minutes: 'minutes',
    hours: 'heures',
    days: 'jours',
    weeks: 'semaines',
    months: 'mois',
    years: 'années',
    ago: 'il y a',
    justNow: 'à l\'instant',
    lessThanMinute: 'moins d\'une minute',
    aboutMinute: 'environ une minute',
    minutesAgo: 'minutes',
    aboutHour: 'environ une heure',
    hoursAgo: 'heures',
    aboutDay: 'environ un jour',
    daysAgo: 'jours'
  },

  // Numbers
  numbers: {
    zero: 'zéro',
    one: 'un',
    two: 'deux',
    three: 'trois',
    four: 'quatre',
    five: 'cinq',
    six: 'six',
    seven: 'sept',
    eight: 'huit',
    nine: 'neuf',
    ten: 'dix'
  },

  // Dashboard
  dashboard: {
    welcomeBack: 'Bon retour, Enseignant!',
    readyToInspire: 'Prêt à inspirer vos élèves aujourd\'hui ? Vous avez {count} leçons disponibles.',
    totalLessons: 'Total des leçons',
    completedSessions: 'Sessions terminées',
    totalStudents: 'Total des élèves',
    averageRating: 'Note moyenne',
    thisMonth: 'ce mois',
    thisWeek: 'cette semaine',
    quickActions: 'Actions rapides',
    browseLessons: 'Parcourir les leçons',
    findNextLesson: 'Trouvez votre prochaine leçon',
    startSession: 'Commencer une session',
    beginTeaching: 'Commencer à enseigner maintenant',
    viewSchedule: 'Voir le planning',
    checkCalendar: 'Vérifiez votre calendrier',
    analytics: 'Analyses',
    viewProgress: 'Voir votre progression',
    recentLessons: 'Leçons récentes',
    viewAll: 'Voir tout',
    noLessonsYet: 'Aucune leçon disponible pour le moment.',
    createFirstLesson: 'Créer votre première leçon'
  },

  // Lesson Library
  lessonLibrary: {
    title: 'Bibliothèque de Leçons',
    description: 'Parcourez et liez les leçons créées par l\'administrateur à votre compte',
    searchLessons: 'Rechercher des leçons...',
    loading: 'Chargement des leçons...',
    results: '{count} leçons trouvées',
    noLessons: 'Aucune leçon trouvée',
    noLessonsDescription: 'Aucune leçon d\'administrateur ne correspond à vos filtres actuels.',
    linkLesson: 'Lier la Leçon',
    alreadyLinked: 'Déjà Liée',
    linkSuccess: 'Leçon liée avec succès !',
    linkError: 'Échec de la liaison de la leçon',
    fetchError: 'Échec du chargement des leçons',
    loginRequired: 'Veuillez vous connecter pour lier des leçons'
  },

  // Lesson List
  lessonList: {
    lessons: 'Leçons',
    browseAndManage: 'Parcourir et gérer vos plans de cours',
    createLesson: 'Créer une leçon',
    searchLessons: 'Rechercher des leçons...',
    all: 'Tout',
    mostRecent: 'Plus récent',
    titleAZ: 'Titre A-Z',
    duration: 'Durée',
    lessonFound: 'leçon trouvée',
    lessonsFound: 'leçons trouvées',
    min: 'min',
    steps: 'étapes',
    students: 'élèves',
    deleteLesson: 'Supprimer la leçon',
    viewTrackingData: 'Voir les données de suivi',
    edit: 'Modifier',
    start: 'Commencer',
    deleteConfirm: 'Êtes-vous sûr de vouloir supprimer "{title}" ? Cette action ne peut pas être annulée.',
    lessonDeleted: 'Leçon supprimée avec succès',
    deleteFailed: 'Échec de la suppression de la leçon',
    noDescription: 'Aucune description disponible',
    noLessonsFound: 'Aucune leçon trouvée',
    adjustSearchCriteria: 'Essayez d\'ajuster vos critères de recherche',
    getStartedCreating: 'Commencez par créer votre première leçon',
    createYourFirstLesson: 'Créer votre première leçon',
    slides: 'Slides',
    openSlides: 'Ouvrir la vue slide scriptée'
  },

  lessonSlides: {
    loading: 'Chargement de la vue slide...',
    unavailableTitle: 'Vue slide indisponible',
    unavailableDescription: 'Cette leçon n’a pas pu être chargée ou ne contient pas d’étapes de timeline.',
    backToLessons: 'Retour aux leçons',
    lessons: 'Leçons',
    arrowsHint: 'Utilisez les flèches Gauche/Droite',
    progress: 'Slide {slide} / {total} • Étape {step} • {name}',
    stepFallback: 'Étape {n}',
    sessionTitle: 'Séance {n} : {name}',
    instructionalFlow: 'Flux pédagogique : Je fais -> Nous faisons -> Tu fais',
    goalLine: 'Objectif : exécuter cette étape avec modélisation explicite, réponse guidée et vérifications rapides.',
    iDoTitle: 'Je fais (Script enseignant)',
    iDoSubtitle: 'Modélisation et instruction explicite',
    weYouTitle: 'Nous faisons / Tu fais (Réponse élève)',
    weYouSubtitle: 'Actions et réponses attendues des élèves',
    practiceTitle: 'Pratique autonome',
    practiceSubtitle: 'Exécution en binômes/groupes et correction immédiate',
    practiceFallback1: 'Lancer une pratique en binômes ou petits groupes alignée sur l’objectif.',
    practiceFallback2: 'Circuler et corriger immédiatement.',
    practiceFallback3: 'Après une réponse chorale, interroger des élèves individuellement au hasard.',
    assessmentTitle: 'Évaluation formative',
    assessmentSubtitle: 'Vérifications de compréhension et critères de réussite',
    checkLine: 'Vérification {n} ({type})',
    formativeType: 'formatif',
    promptLabel: 'Prompt',
    lookForLabel: 'À observer',
    expectedLabel: 'Attendu',
    supportLabel: 'Remédiation',
    extensionLabel: 'Enrichissement',
    adaptivityLabel: 'Règle d’adaptivité',
    diffTitle: 'Différenciation & Suivi',
    diffSubtitle: 'Remédiation, enrichissement et adaptivité',
    stepTypes: {
      warmup: 'Échauffement',
      launch: 'Lancement',
      directInstruction: 'Instruction directe',
      guidedPractice: 'Pratique guidée',
      independentPractice: 'Pratique autonome',
      closing: 'Clôture'
    }
  },

  // Header
  header: {
    appTitle: 'TeacherApp',
    searchLessons: 'Rechercher des leçons...',
    teacherName: 'Nom de l\'enseignant'
  },

  // Learning Objectives
  learningObjectives: {
    learningObjectives: 'Objectifs spécifiques',
    addObjective: 'Ajouter un objectif spécifique',
    objective: 'Objectif spécifique',
    successCriteria: 'Critères de réussite',
    addSuccessCriteria: 'Ajouter des critères de réussite',
    successCriteriaItem: 'Critère de réussite',
    standardsAlignment: 'Alignement des standards',
    addStandard: 'Ajouter un standard',
    standard: 'Standard',
    standardPlaceholder: 'Standard {index} (ex: CCSS.MATH.CONTENT.1.NBT.A.1)'
  },

  // Materials
  materials: {
    materialsAndResources: 'Matériaux et ressources',
    digitalMaterials: 'Matériaux numériques',
    physicalMaterials: 'Matériaux physiques',
    addDigitalMaterial: 'Ajouter un matériau numérique',
    addPhysicalMaterial: 'Ajouter un matériau physique',
    digitalMaterial: 'Matériau numérique',
    physicalMaterial: 'Matériau physique'
  },

  // Timer
  timer: {
    timer: 'Minuteur'
  },

  // Image Component
  image: {
    image: 'Image',
    noImageUrl: 'Aucune URL d\'image fournie',
    provideImageUrl: 'Veuillez fournir une URL d\'image dans la configuration de la ressource',
    loadError: 'Échec du chargement de l\'image'
  },

  // Image Configuration Form
  imageConfig: {
    uploadImage: 'Télécharger une image',
    selectFile: 'Sélectionner un fichier image',
    uploading: 'Téléchargement...',
    uploadHint: 'Téléchargez un fichier image (JPEG, PNG, GIF, WebP, SVG). Taille max : 5 Mo',
    or: 'OU',
    imageUrl: 'URL de l\'image',
    urlHint: 'Entrez une URL directe vers une image',
    altText: 'Texte alternatif',
    altTextPlaceholder: 'Description de l\'image',
    altTextHint: 'Texte alternatif pour l\'accessibilité',
    caption: 'Légende',
    captionPlaceholder: 'Légende optionnelle à afficher sous l\'image',
    alignment: 'Alignement',
    left: 'Gauche',
    center: 'Centre',
    right: 'Droite',
    fitMode: 'Mode d\'ajustement',
    contain: 'Contenir - Ajuster l\'image dans les limites',
    cover: 'Couvrir - Remplir les limites, peut recadrer',
    fill: 'Remplir - Étirer pour remplir les limites',
    fitModeHint: 'Comment l\'image doit s\'ajuster dans son conteneur',
    width: 'Largeur',
    height: 'Hauteur',
    preview: 'Aperçu',
    removeImage: 'Supprimer l\'image',
    invalidFileType: 'Type de fichier invalide. Veuillez sélectionner un fichier image (JPEG, PNG, GIF, WebP, SVG)',
    fileTooLarge: 'Le fichier est trop volumineux. La taille maximale est de 5 Mo',
    uploadError: 'Échec du téléchargement de l\'image. Veuillez réessayer.',
    invalidImageUrl: 'URL d\'image invalide ou échec du chargement de l\'image',
    notAuthenticated: 'Vous devez être connecté pour télécharger des images. Veuillez vous connecter et réessayer.',
    authenticationRequired: 'Authentification requise',
    authenticationHint: 'Vous devez être connecté pour télécharger des images. Veuillez d\'abord vous connecter à votre compte.',
    corsError: 'Erreur CORS : Veuillez vérifier votre configuration Firebase Storage. Assurez-vous que les règles CORS sont correctement configurées et que vous êtes authentifié.',
    permissionError: 'Permission refusée (403). Veuillez vérifier vos règles de sécurité Firebase Storage. Assurez-vous que les utilisateurs authentifiés peuvent écrire dans le dossier "images/".',
    checkDocumentation: 'Voir docs/FIREBASE_STORAGE_SETUP.md pour les instructions détaillées de configuration.'
  },

  // Rich Text Component
  richText: {
    richText: 'Texte enrichi',
    noContent: 'Aucun contenu fourni',
    provideContent: 'Veuillez fournir du contenu dans la configuration de la ressource'
  },

  // Rich Text Configuration Form
  richTextConfig: {
    title: 'Titre',
    titlePlaceholder: 'Titre optionnel pour le contenu',
    titleHint: 'Titre optionnel affiché au-dessus du contenu',
    content: 'Contenu',
    contentPlaceholder: 'Entrez votre contenu texte ici...',
    contentHint: 'Utilisez la barre d\'outils pour formater votre texte. Supporte le formatage HTML.',
    preview: 'Aperçu',
    alignment: 'Alignement du texte',
    left: 'Gauche',
    center: 'Centre',
    right: 'Droite',
    justify: 'Justifié',
    fontSize: 'Taille de police',
    inherit: 'Hérité (par défaut)',
    backgroundColor: 'Couleur de fond',
    textColor: 'Couleur du texte',
    maxWidth: 'Largeur maximale',
    maxWidthHint: 'Largeur maximale du contenu (ex: 800px, 100%, none)',
    padding: 'Marge intérieure',
    paddingHint: 'Marge intérieure autour du contenu (ex: 1rem, 16px, 1rem 2rem)'
  },

  // Tracking Dashboard
  trackingDashboard: {
    trackingDashboard: 'Tableau de bord de suivi',
    noActiveSession: 'Aucune session de leçon active pour le suivi.',
    lesson: 'Leçon',
    status: 'Statut',
    active: 'Actif',
    disabled: 'Désactivé',
    refreshData: 'Actualiser les données',
    totalEvents: 'Total des événements',
    totalTime: 'Temps total',
    students: 'Élèves',
    completionRate: 'Taux de réussite',
    lessonSummary: 'Résumé de la leçon',
    averageTime: 'Temps moyen',
    minutes: 'minutes',
    averageScore: 'Score moyen',
    engagementRate: 'Taux d\'engagement',
    lastActivity: 'Dernière activité',
    recentEvents: 'Événements récents',
    noEventsRecorded: 'Aucun événement enregistré pour le moment.',
    exportData: 'Exporter les données',
    exporting: 'Exportation...',
    export: 'Exporter',
    clearData: 'Effacer les données',
    clearDataConfirm: 'Êtes-vous sûr de vouloir effacer toutes les données de suivi pour cette leçon ? Cette action ne peut pas être annulée.',
    student: 'Élève',
    unknownTime: 'Heure inconnue',
    invalidTime: 'Heure invalide'
  },

  // UI Component Selector
  uiComponentSelector: {
    selectUIComponentType: 'Sélectionner le type de composant UI'
  },

  // Activity Component
  activityComponent: {
    interactiveActivity: 'Activité interactive',
    mode: 'Mode',
    audio: 'Audio',
    enabled: 'Activé',
    disabled: 'Désactivé',
    startActivity: 'Commencer l\'activité',
    activityInProgress: 'Activité en cours...',
    score: 'Score',
    completeActivity: 'Terminer l\'activité'
  },

  // Assessments Section
  assessmentsSection: {
    assessments: 'Évaluations',
    addAssessment: 'Ajouter une évaluation',
    removeAssessment: 'Supprimer l\'évaluation',
    addItem: 'Ajouter un élément',
    removeItem: 'Supprimer l\'élément',
    assessmentItem: 'Élément d\'évaluation',
    type: 'Type',
    selectType: 'Sélectionner un type',
    quizResource: 'Ressource de quiz',
    countObjects: 'Compter les objets',
    tenFrameRead: 'Lecture de cadre de dix',
    numberLinePoint: 'Point sur la ligne numérique',
    beforeAfter: 'Avant/Après',
    composeNumbers: 'Composer les nombres',
    sequence: 'Séquence',
    pattern: 'Motif',
    comparison: 'Comparaison',
    multipleChoice: 'Choix multiple',
    stimulus: 'Stimulus',
    enterPrompt: 'Entrer la consigne ou question',
    choices: 'Choix',
    addChoice: 'Ajouter un choix',
    choice: 'Choix',
    selectResource: 'Sélectionner une ressource',
    noQuizResources: 'Aucune ressource de quiz disponible',
    createQuizResources: 'Créez d\'abord des ressources de quiz',
    scoring: 'Notation',
    pointsPerCorrect: 'Points par réponse correcte',
    maxScore: 'Score maximum',
    masteryThreshold: 'Seuil de maîtrise',
    timeLimit: 'Limite de temps',
    minutes: 'minutes',
    autoStart: 'Démarrage automatique',
    configuration: 'Configuration',
    minValue: 'Valeur minimum',
    maxValue: 'Valeur maximum',
    numBefore: 'Nombre avant',
    numAfter: 'Nombre après',
    showHint: 'Afficher l\'indice',
    firstNumber: 'Premier nombre',
    secondNumber: 'Deuxième nombre',
    baseNumber: 'Nombre de base',
    questionType: 'Type de question',
    before: 'Avant',
    after: 'Après',
    between: 'Entre',
    answer: 'Réponse',
    prompt: 'Consigne',
    enterQuestionPrompt: 'Entrer la consigne de question',
    selectQuizResource: 'Sélectionner une ressource de quiz',
    selectQuizResourcePlaceholder: 'Sélectionner une ressource de quiz...',
    noQuizResourcesAvailable: 'Aucune ressource de quiz disponible. Créez d\'abord une ressource de quiz dans l\'onglet Ressources.',
    quizResourceDetails: 'Détails de la ressource de quiz:',
    resourceId: 'ID de ressource:',
    questions: 'Questions:',
    shuffle: 'Mélanger:',
    questionExamples: 'Exemples de questions:',
    question: 'Question',
    andMore: 'et {count} de plus',
    whatComesBefore: 'Qu\'est-ce qui vient avant?',
    whatComesAfter: 'Qu\'est-ce qui vient après?',
    whatComesBetween: 'Qu\'est-ce qui vient entre?',
    secondNumberForBetween: 'Deuxième nombre (pour entre)',
    objectCount: 'Nombre d\'objets',
    layout: 'Disposition',
    frameValue: 'Valeur du cadre',
    numberLineRange: 'Plage de la ligne numérique',
    markedPosition: 'Position marquée',
    yes: 'Oui',
    no: 'Non',
    answerChoices: 'Choix de réponse',
    questionPrompt: 'Consigne de question',
    correctAnswer: 'Réponse correcte',
    enterCorrectAnswer: 'Entrer la réponse correcte',
    enterChoices: 'Entrer les choix (séparés par des virgules)',
    correctAnswerMustBeOneOfTheChoices: 'La réponse correcte doit être l\'un des choix',
    addQuestion: 'Ajouter une question',
    addResource: 'Ajouter une ressource',
    includeResource: 'Inclure une ressource interactive',
    addInteractiveComponent: 'Ajouter un composant interactif (ex: compter les objets)',
    quickAdd: 'Ajout rapide',
    addNewQuestion: 'Ajouter une nouvelle question',
    rows: 'Lignes',
    columns: 'Colonnes',
    howManyObjectsDoYouSee: 'Combien d\'objets voyez-vous ?',
    whatNumberComesAfter9: 'Quel nombre vient après 9 ?',
    whatIs5Plus3: 'Qu\'est-ce que 5 + 3 ?',
    removeChoice: 'Supprimer un choix',
    answerNotInChoices: 'Réponse non dans les choix !',
    interactiveResource: 'Ressource interactive',
    resourceType: 'Type de ressource',
    objectsCount: 'Nombre d\'objets',
    randomClustered: 'Aléatoire groupé',
    twoGroups: 'Deux groupes',
    linear: 'Linéaire',
    randomize: 'Aléatoire',
    randomizeObjectPositions: 'Aléatoire les positions des objets',
    tickEvery: 'Toutes les',
    markPosition: 'Marquer la position',
    bank: 'Banque (séparés par des virgules)',
    bankPlaceholder: '0, 1, 2, 3, 4, 5',
    mode: 'Mode',
    readAndSelect: 'Lire et sélectionner',
    dragAndDrop: 'Glisser-déposer',
    clickToFill: 'Cliquer pour remplir',
    autoFlip: 'Retourner automatiquement',
    cards: 'Cartes (séparées par des virgules)',
    cardsPlaceholder: 'A, B, C, D, E',
    autoFlipCards: 'Retourner automatiquement les cartes',
    
    // Number Line Stimulus Advanced Options
    markStyle: 'Style de marquage',
    colorTheme: 'Thème de couleur',
    showRangeLabels: 'Afficher les étiquettes de plage (début-fin)',
    showStepInfo: 'Afficher les informations d\'étape',
    advancedOptions: 'Options avancées',
    points: 'Points',
    autoAdvanceSeconds: 'Avance automatique en secondes',
    showProgress: 'Afficher le progrès',
    autoAdvance: 'Avance automatique',

    // SLAM item bank integration
    addFromSlam: 'Ajouter depuis SLAM',
    slamItem: 'Item SLAM',
    slamItemBadge: 'SLAM #{id}',
    slamDomain: 'Domaine',
    slamSkill: 'Compétence',
    slamGrade: 'Niveau',
    slamDifficulty: 'Difficulté {level}',
    slamDescription: 'Description',
    slamIndication: 'Indication',
    slamIntroduction: 'Introduction',
  },

  // SLAM Item Picker
  slamPicker: {
    title: 'Sélectionner des items SLAM',
    selected: '{count} sélectionné(s)',
    searchPlaceholder: 'Rechercher...',
    gradePlaceholder: 'Niveau (ex: CP)',
    allGrades: 'Tous les niveaux',
    allDomains: 'Tous les domaines',
    exposeToAssessmentOnly: 'Évaluations uniquement',
    allSkills: 'Toutes les compétences',
    diffMin: 'Diff. min',
    diffMax: 'Diff. max',
    search: 'Rechercher',
    noResults: 'Aucun item trouvé. Modifiez les filtres et relancez la recherche.',
    cancel: 'Annuler',
    add: 'Ajouter',
    addCount: 'Ajouter ({count})',
    selectHint: 'Cliquez sur un item pour le sélectionner',
    selectedHint: '{count} item sélectionné',
    selectedHintPlural: '{count} items sélectionnés',
    page: 'Page {page} / {total} ({count} résultats)',
    difficulty1: 'Très facile',
    difficulty2: 'Facile',
    difficulty3: 'Moyen',
    difficulty4: 'Difficile',
    difficulty5: 'Très difficile',
    difficultyLevel: 'Niveau {level}',
    errorSearch: 'Erreur lors de la recherche SLAM',
    slamExercise: 'Exercice SLAM',
    indication: 'Indication',
    introduction: 'Introduction',
    versionsCount: '{count} versions',
    chooseVersion: 'Choisir une version',
    versionMain: 'Version principale',
    versionAlt: 'Version alternative {n}',
    versionChosen: 'Version {n}/{total} sélectionnée',
    response: 'Réponse',
  },

  // Data and Reporting Section
  dataAndReporting: {
    dataAndReporting: 'Données et rapports',
    trackingEvents: 'Événements de suivi',
    addEvent: 'Ajouter un événement',
    addPresetEvent: 'Ajouter un événement prédéfini',
    removeEvent: 'Supprimer l\'événement',
    eventName: 'Nom de l\'événement',
    when: 'Quand',
    capture: 'Capturer',
    description: 'Description',
    enterEventName: 'Entrer le nom de l\'événement',
    selectTrigger: 'Sélectionner un déclencheur',
    enterDescription: 'Entrer la description',
    addDataPoint: 'Ajouter un point de données',
    dataPoint: 'Point de données',
    groupingRules: 'Règles de regroupement',
    addRule: 'Ajouter une règle',
    addPresetRule: 'Ajouter une règle prédéfinie',
    removeRule: 'Supprimer la règle',
    rule: 'Règle',
    enterRule: 'Entrer la règle de regroupement',
    reportingSettings: 'Paramètres de rapport',
    frequency: 'Fréquence',
    selectFrequency: 'Sélectionner la fréquence',
    realTime: 'Temps réel',
    daily: 'Quotidien',
    weekly: 'Hebdomadaire',
    monthly: 'Mensuel',
    format: 'Format',
    selectFormat: 'Sélectionner le format',
    dashboard: 'Tableau de bord',
    exportOptions: 'Options d\'exportation',
    csv: 'CSV',
    json: 'JSON',
    pdf: 'PDF',
    enableAutoExport: 'Activer l\'export automatique',
    retentionDays: 'Jours de rétention',
    privacySettings: 'Paramètres de confidentialité',
    anonymizeData: 'Anonymiser les données',
    enableEncryption: 'Activer le chiffrement',
    requireConsent: 'Exiger le consentement',
    // Preset events
    assessmentCompletion: 'Achèvement de l\'évaluation',
    trackAssessmentPerformance: 'Suivre l\'achèvement et la performance de l\'évaluation',
    stepCompletion: 'Achèvement de l\'étape',
    trackStepCompletion: 'Suivre l\'achèvement des étapes de la chronologie',
    resourceInteraction: 'Interaction avec les ressources',
    trackResourceInteractions: 'Suivre les interactions des élèves avec les ressources',
    quizResponse: 'Réponse au quiz',
    trackQuizResponses: 'Suivre les réponses individuelles aux questions du quiz',
    engagementCheck: 'Vérification de l\'engagement',
    trackEngagement: 'Suivre l\'engagement et la participation des élèves',
    exitTicket: 'Billet de sortie',
    whenToCapture: 'Quand capturer',
    dataToCapture: 'Données à capturer',
    addEventsToTrack: 'Ajouter des événements à suivre',
    noDataEventsConfigured: 'Aucun événement de suivi configuré pour le moment.',
    configureAnalytics: 'Configurer les analyses',
    studentTrackingOptions: 'Options de suivi des élèves',
    progressTracking: 'Suivi des progrès',
    trackCompletionRates: 'Suivre les taux de réussite',
    timeTracking: 'Suivi du temps',
    monitorTimeSpent: 'Suivre le temps passé',
    engagementMetrics: 'Mesures d\'engagement',
    trackInteractions: 'Suivre les interactions',
    reportingConfiguration: 'Configuration des rapports',
    trackExitTicketResponses: 'Suivre les réponses aux billets de sortie',
    analyticsSettings: 'Paramètres d\'analyse',
    enableAnalytics: 'Activer l\'analyse',
    trackStudentPerformance: 'Suivre la performance et l\'engagement des élèves',
    configureReporting: 'Configurer comment et quand générer des rapports',
    reportingFrequency: 'Fréquence des rapports',
    endOfLesson: 'Fin de la leçon',
    exportFormats: 'Formats d\'exportation',
    spreadsheetFormat: 'Format de tableau',
    printableReports: 'Rapports imprimables',
    dataExport: 'Exportation des données',
    nextLessonGroupingRule: 'Règle de regroupement de la prochaine leçon',
    viewPresets: 'Voir les préréglages',
    quickAddPresetRules: 'Ajout rapide de préréglages',
    nextLessonGroupingRulePlaceholder: 'ex. : Si le score < 70%, assigner des activités de remédiation; sinon, assigner des activités enrichissantes.',
    nextLessonGroupingRuleDescription: 'Définir des règles pour regrouper automatiquement les élèves pour la prochaine leçon en fonction de leur performance.',
    addField: 'Ajouter un champ',
    presetEvents: {
      assessment_complete: {
        description: 'Suivre l\'achèvement et la performance de l\'évaluation'
      },
      step_complete: {
        description: 'Suivre l\'achèvement des étapes de la chronologie'
      },
      exit_ticket_submit: {
        description: 'Suivre la soumission des billets de sortie'
      },
      resource_interaction: {
        description: 'Suivre les interactions des élèves avec les ressources'
      },
      quiz_response: {
        description: 'Suivre les réponses individuelles aux questions du quiz'
      },
      engagement_check: {
        description: 'Suivre l\'engagement et la participation des élèves'
      }
    },
    presetGroupingRules: {
      'score_below_70': 'Si le score < 70%, assigner des activités de remédiation; sinon, assigner des activités enrichissantes.',
      'engagement_below_50': 'Si l\'engagement < 50%, fournir un soutien supplémentaire; sinon, assigner des travaux avancés.',
      'time_spent_above_120': 'Si le temps passé > 120% du temps attendu, assigner une version simplifiée; sinon, assigner une version standard.',
      'correct_answers_below_3': 'Si le nombre de réponses correctes < 3, assigner \'Build Foundation\' practice; else assign \'Extend Learning\' practice.',
      'participation_below_2': 'If participation < 2 interactions, assign guided practice; else assign independent practice.'
    },
    configureDataCollectionEvents: 'Configurer quand et quelles données collecter pendant les leçons',
    dataCollectionEvents: 'Événements de collecte de données',
    presets: 'Préréglages',
    addCustom: 'Ajouter personnalisé',
    quickAddPresetEvents: 'Ajout rapide de préréglages',
    event: 'Événement',
    briefDescriptionOfThisEvent: 'Description briève de cet événement',
    captures: 'Captures'
  },

  // Differentiation Section
  differentiation: {
    differentiation: 'Différenciation',
    configureStrategies: 'Configurer les stratégies pour répondre aux besoins de tous les élèves',
    supports: 'Supports',
    extensions: 'Extensions',
    ellSupport: 'Support ELL',
    supportDiverseLearners: 'Soutenir des apprenants diversifiés avec des stratégies ciblées',
    supportsForStrugglingLearners: 'Soutiens pour les élèves en difficulté',
    strategiesForAdditionalSupport: 'Stratégies pour aider les élèves qui ont besoin de soutien supplémentaire',
    presets: 'Préréglages',
    addCustom: 'Ajouter personnalisé',
    quickAddPresetStrategies: 'Ajout rapide de stratégies prédéfinies',
    describeSupportStrategy: 'Décrivez la stratégie de soutien...',
    noSupportStrategies: 'Aucune stratégie de soutien configurée pour le moment.',
    addStrategiesToHelp: 'Ajoutez des stratégies pour aider les élèves en difficulté à réussir.',
    extensionsForAdvancedLearners: 'Extensions pour les apprenants avancés',
    challengeActivitiesForStudents: 'Activités défi pour les élèves qui ont besoin de plus de rigueur',
    quickAddPresetExtensions: 'Ajout rapide d\'extensions prédéfinies',
    describeExtensionActivity: 'Décrivez l\'activité d\'extension...',
    noExtensionActivities: 'Aucune activité d\'extension configurée pour le moment.',
    addChallengingActivities: 'Ajoutez des activités stimulantes pour les apprenants avancés.',
    ellSupportFull: 'Soutien aux apprenants de langue anglaise (ELL)',
    languageScaffolding: 'Échafaudage linguistique et supports visuels pour les élèves ELL',
    sentenceFrames: 'Structures de phrases',
    provideLanguageStructures: 'Fournir des structures linguistiques pour que les élèves expriment leur réflexion',
    quickAddSentenceFrames: 'Ajout rapide de structures de phrases',
    sentenceFrameExample: 'ex. : Je pense ___ parce que ___.',
    noSentenceFrames: 'Aucune structure de phrase configurée pour le moment.',
    addLanguageStructures: 'Ajoutez des structures linguistiques pour soutenir les élèves ELL.',
    visualIcons: 'Icônes visuelles',
    nonVerbalCues: 'Indices non verbaux et supports visuels pour la communication',
    quickAddVisualIcons: 'Ajout rapide d\'icônes visuelles',
    visualIconExample: 'ex. : toucher, dire, bouger, compter',
    noVisualIcons: 'Aucune icône visuelle configurée pour le moment.',
    addNonVerbalCues: 'Ajoutez des indices non verbaux pour soutenir les élèves ELL.',
    adaptiveScaffolding: 'Échafaudage adaptatif',
    multimodalSupport: 'Support multimodal',
    personalizedPacing: 'Rythme personnalisé',
    criteriaBasedGrouping: 'Regroupement basé sur les critères',
    addScaffold: 'Ajouter un échafaudage',
    removeScaffold: 'Supprimer l\'échafaudage',
    condition: 'Condition',
    action: 'Action',
    selectCondition: 'Sélectionner une condition',
    selectAction: 'Sélectionner une action',
    addSupport: 'Ajouter un support',
    removeSupport: 'Supprimer le support',
    supportType: 'Type de support',
    selectSupportType: 'Sélectionner le type de support',
    addPacingRule: 'Ajouter une règle de rythme',
    removePacingRule: 'Supprimer la règle de rythme',
    studentCriteria: 'Critères de l\'élève',
    pacingAdjustment: 'Ajustement du rythme',
    addGroupingRule: 'Ajouter une règle de regroupement',
    removeGroupingRule: 'Supprimer la règle de regroupement',
    groupingCriteria: 'Critères de regroupement',
    resultingGroup: 'Groupe résultant'
  },

  // Differentiation Display
  differentiationDisplay: {
    differentiationStrategies: 'Stratégies de différenciation',
    noStrategiesConfigured: 'Aucune stratégie de différenciation n\'a été configurée pour cette leçon.',
    configureStrategiesInEditor: 'Configurez des stratégies dans l\'éditeur de leçon pour soutenir des apprenants diversifiés.',
    strategiesToSupportLearners: 'Stratégies pour soutenir des apprenants diversifiés',
    supportsForStrugglingLearners: 'Soutiens pour les élèves en difficulté',
    extensionsForAdvancedLearners: 'Extensions pour les apprenants avancés',
    ellSupport: 'Soutien aux apprenants de langue anglaise (ELL)',
    sentenceFrames: 'Structures de phrases',
    visualIcons: 'Icônes visuelles',
    useStrategiesToSupport: 'Utilisez ces stratégies pour soutenir des apprenants diversifiés pendant l\'instruction',
    differentiationReady: 'Différenciation prête'
  },

  // Import Export Section
  importExport: {
    importExport: 'Importer/Exporter',
    importLesson: 'Importer une leçon',
    exportLesson: 'Exporter la leçon',
    selectFile: 'Sélectionner un fichier',
    chooseFile: 'Choisir un fichier',
    importButton: 'Importer',
    lessonImported: 'Leçon importée avec succès',
    importFailed: 'Échec de l\'importation de la leçon',
    invalidFile: 'Fichier invalide ou format non supporté',
    exportAs: 'Exporter en tant que',
    download: 'Télécharger',
    exportFailed: 'Échec de l\'exportation',
    importDescription: 'Importer une leçon depuis un fichier JSON',
    exportDescription: 'Télécharger la leçon actuelle en JSON',
    sampleLesson: 'Leçon d\'exemple',
    sampleLessonDescription: 'Télécharger un modèle de leçon d\'exemple',
    downloadSample: 'Télécharger l\'exemple',
    importExportInformation: 'Informations d\'importation/exportation',
    importInfo1: 'Importer des leçons depuis des fichiers JSON pour charger rapidement du contenu existant',
    importInfo2: 'Exporter des leçons pour les partager avec d\'autres enseignants ou sauvegarder votre travail',
    importInfo3: 'Télécharger la leçon d\'exemple pour voir la structure complète de la leçon',
    importInfo4: 'Toutes les données de la leçon incluant les ressources, la chronologie et les évaluations sont incluses'
  },

  // Timeline Steps Section
  timelineSteps: {
    timelineSteps: 'Étapes de la chronologie',
    addStep: 'Ajouter une étape',
    step: 'Étape',
    removeStep: 'Supprimer l\'étape',
    moveUp: 'Monter',
    moveDown: 'Descendre',
    collapseStep: 'Réduire l\'étape',
    expandStep: 'Agrandir l\'étape',
    minutes: 'min',
    moveResourceUp: 'Monter la ressource',
    moveResourceDown: 'Descendre la ressource',
    stepName: 'Nom de l\'étape',
    enterStepName: 'Entrer le nom de l\'étape',
    duration: 'Durée',
    stepType: 'Type d\'étape',
    warmUp: 'Échauffement',
    launch: 'Lancement',
    directInstruction: 'Instruction directe',
    guidedPractice: 'Pratique guidée',
    independentPractice: 'Pratique indépendante',
    closing: 'Clôture',
    teacherScript: 'Script de l\'enseignant',
    addScript: 'Ajouter un script',
    enterTeacherScript: 'Entrer le script de l\'enseignant',
    scriptSegment: 'Segment de Script',
    removeScript: 'Supprimer le Script',
    studentActions: 'Actions des élèves',
    addAction: 'Ajouter une action',
    enterStudentAction: 'Entrer l\'action de l\'élève',
    checksForUnderstanding: 'Vérifications de compréhension',
    addCheck: 'Ajouter une vérification',
    enterCheckForUnderstanding: 'Entrer une vérification de compréhension',
    checkType: 'Type de Vérification',
    observation: 'Observation',
    question: 'Question',
    quickPoll: 'Sondage Rapide',
    exitTicket: 'Billet de Sortie',
    prompt: 'Question',
    lookFor: 'À Observer',
    enterLookFor: 'Entrez ce qu\'il faut observer',
    commonError: 'Erreur Commune',
    enterCommonError: 'Entrez l\'erreur commune à éviter',
    
    // Resources
    resources: 'Ressources',
    selectResource: 'Sélectionner une ressource à attacher',
    removeResource: 'Supprimer la ressource',
    configureResource: 'Configurer la ressource',
    customConfig: 'Config personnalisée',
    noResourcesAttached: 'Aucune ressource attachée à cette étape',
    noResourcesAvailable: 'Aucune ressource disponible. Créez d\'abord des ressources dans l\'onglet Ressources.'
  },

  // Flashcard Set Component
  flashcardSet: {
    flashcardSet: 'Jeu de cartes mémoire',
    noItemsConfigured: 'Aucun élément configuré',
    card: 'Carte',
    of: 'sur',
    next: 'Suivant',
    previous: 'Précédent',
    flip: 'Retourner',
    autoAdvance: 'Avance automatique',
    stopAutoAdvance: 'Arrêter l\'avance automatique'
  },

  // Memory Game Component
  memoryGame: {
    memoryGame: 'Jeu de mémoire',
    matchEmojiWithName: 'Associez l\'emoji avec son nom',
    startGame: 'Commencer le jeu',
    resetGame: 'Recommencer',
    matchedPairs: 'Paires trouvées',
    status: 'Statut',
    completed: 'Terminé',
    inProgress: 'En cours',
    congratulations: 'Félicitations !',
    gameCompletedMessage: 'Vous avez terminé le jeu de mémoire !',
    noItemsConfigured: 'Aucun élément configuré pour le jeu',
    card: 'Carte',
    of: 'sur',
    flip: 'Retourner',
    match: 'Correspondance',
    noMatch: 'Pas de correspondance'
  },


  // Feedback Component
  feedback: {
    feedback: 'Retour d\'information',
    type: 'Type',
    showAnswers: 'Afficher les réponses',
    yes: 'Oui',
    no: 'Non',
    enterFeedback: 'Entrez votre retour d\'information...',
    submitFeedback: 'Soumettre le retour',
    thankYou: 'Merci pour votre retour d\'information !'
  },

  // Grid Activity Component
  gridActivity: {
    gridActivity: 'Activité de grille',
    mode: 'Mode',
    reset: 'Réinitialiser',
    clearSelection: 'Effacer la sélection',
    selected: 'Sélectionné',
    cells: 'cellules'
  },

  // Resource Selector
  resourceSelector: {
    resources: 'Ressources',
    addResource: 'Ajouter une ressource',
    id: 'ID',
    configure: 'Configurer',
    hideConfiguration: 'Masquer la configuration'
  },

  // Resource Type Selector
  resourceTypeSelector: {
    selectResourceType: 'Sélectionner le type de ressource'
  },

  // Resource Types
  resourceTypes: {
    numberLine: 'Ligne numérique',
    numberLineDescription: 'Ligne numérique interactive pour compter et le sens des nombres',
    tenFrame: 'Cadre de dix',
    tenFrameDescription: 'Cadre de dix interactif pour la représentation des nombres',
    countObjects: 'Compter les objets',
    countObjectsDescription: 'Canvas interactif pour compter les objets',
    matchingObjects: 'Objets correspondants',
    matchingObjectsDescription: 'Faire correspondre différentes représentations de quantités',
    timer: 'Minuteur',
    timerDescription: 'Minuteur pour les activités',
    quiz: 'Quiz rapide',
    quizDescription: 'Outil d\'évaluation interactive',
    sampleQuestion1: 'Combien d\'objets voyez-vous ?',
    sampleQuestion2: 'Quel nombre vient après 9 ?',
    image: 'Image',
    imageDescription: 'Afficher une image dans la leçon',
    richText: 'Texte enrichi',
    richTextDescription: 'Afficher du contenu texte formaté avec support HTML',
    interactiveDiagram: 'Diagramme interactif',
    interactiveDiagramDescription: 'Diagramme interactif avec des étapes cliquables',
    stage1: 'Étape 1',
    stage1Description: 'Description de la première étape',
    stage1Details: 'Informations détaillées sur l\'étape 1',
    stage2: 'Étape 2',
    stage2Description: 'Description de la deuxième étape',
    stage2Details: 'Informations détaillées sur l\'étape 2',
    stage3: 'Étape 3',
    stage3Description: 'Description de la troisième étape',
    stage3Details: 'Informations détaillées sur l\'étape 3',
    simulation: 'Simulation de laboratoire virtuel',
    simulationDescription: 'Simulation d\'expérience scientifique interactive',
    water: 'Eau',
    waterDescription: 'Eau liquide pour l\'expérience',
    heat: 'Source de chaleur',
    heatDescription: 'Chaleur pour évaporer l\'eau',
    condensationChamber: 'Chambre de condensation',
    condensationChamberDescription: 'Zone froide pour la condensation de l\'eau',
    simulationTitle: 'Mini expérience du cycle de l\'eau',
    simulationDataDescription: 'Observer comment l\'eau change d\'état par évaporation et condensation',
    initialSetup: 'Configuration initiale',
    initialSetupDescription: 'Eau à température ambiante',
    readyToStart: 'Prêt à commencer l\'expérience',
    heatingPhase: 'Phase de chauffage',
    heatingPhaseDescription: 'La source de chaleur réchauffe l\'eau',
    heatingWater: 'Chauffage de l\'eau... L\'eau commence à s\'évaporer',
    condensationPhase: 'Phase de condensation',
    condensationPhaseDescription: 'La vapeur d\'eau se refroidit et se condense',
    waterVaporCondensing: 'Vapeur d\'eau se condensant sur une surface froide',
    learningObjective1: 'Comprendre les trois états de l\'eau (solide, liquide, gaz)',
    learningObjective2: 'Observer le processus d\'évaporation',
    learningObjective3: 'Voir comment la condensation forme des gouttelettes d\'eau',
    learningObjective4: 'Se connecter au cycle naturel de l\'eau',
    safetyNote1: 'Ceci est une expérience virtuelle - aucune source de chaleur réelle utilisée',
    safetyNote2: 'Dans les vraies expériences, utilisez toujours un équipement de sécurité approprié',
    safetyNote3: 'Supervision adulte requise pour les vraies expériences de chaleur',
    flashcardSet: 'Jeu de cartes mémoire',
    flashcardSetDescription: 'Cartes mémoire interactives pour l\'apprentissage',
    gridActivity: 'Activité de grille',
    gridActivityDescription: 'Activité d\'apprentissage interactive basée sur une grille',
    audioBank: 'Banque audio',
    audioBankDescription: 'Ressources audio pour l\'apprentissage auditif',
    memoryGame: 'Jeu de mémoire',
    memoryGameDescription: 'Jeu de mémoire interactif pour associer emojis et mots',
    sortingGame: 'Jeu de Tri',
    sortingGameDescription: 'Jeu de tri interactif pour catégoriser les objets',
    zero: 'Zéro',
    one: 'Un',
    two: 'Deux',
    three: 'Trois',
    four: 'Quatre',
    five: 'Cinq',
    six: 'Six',
    seven: 'Sept',
    eight: 'Huit',
    nine: 'Neuf',
    ten: 'Dix',
    // GPF Resource Types
    sortingCanvas: 'Canvas de Tri',
    sortingCanvasDescription: 'Canvas interactif pour les activités de tri et de classification',
    spatialCanvas: 'Canvas Spatial',
    spatialCanvasDescription: 'Canvas interactif pour le positionnement spatial et la topologie',
    topologyCanvas: 'Canvas Topologie',
    topologyCanvasDescription: 'Canvas interactif pour les exercices de topologie dedans/dehors',
    patternMaker: 'Créateur de Rythmes',
    patternMakerDescription: 'Outil interactif pour créer et continuer des patterns',
    drawingBoard: 'Planche à Dessiner',
    drawingBoardDescription: 'Canvas de dessin interactif avec outils et modèles',
    objectManipulator: 'Manipulateur d\'Objets',
    objectManipulatorDescription: 'Outil interactif pour la manipulation et transformation d\'objets',
    shapeRecognition: 'Reconnaissance des Formes',
    shapeRecognitionDescription: 'Activité interactive pour reconnaître et nommer les formes géométriques'
  },

  // UI Component Types
  uiComponentTypes: {
    display: 'Affichage',
    displayDescription: 'Afficher une ressource en lecture seule',
    manipulative: 'Manipulatif',
    manipulativeDescription: 'Ressource interactive pour l\'apprentissage pratique',
    timer: 'Minuteur',
    timerDescription: 'Composant minuteur',
    quiz: 'Quiz',
    quizDescription: 'Composant d\'évaluation',
    activity: 'Activité',
    activityDescription: 'Activité d\'apprentissage interactive',
    assessment: 'Évaluation',
    assessmentDescription: 'Composant d\'évaluation des élèves',
    feedback: 'Retour',
    feedbackDescription: 'Composant de retour des élèves'
  },

  // Resource Configuration Panel
  resourceConfigurationPanel: {
    configure: 'Configurer',
    id: 'ID'
  },

  // Resources Panel
  resourcesPanel: {
    resources: 'Ressources',
    resourcesForStep: 'ressources pour cette étape',
    noResources: 'Aucune ressource',
    noResourcesDescription: 'Aucune ressource n\'est attachée à cette étape.',
    unsupportedResourceType: 'Type de ressource non pris en charge',
    customConfig: 'Config personnalisée',
    expand: 'Développer',
    collapse: 'Réduire',
    minimize: 'Minimiser',
    maximize: 'Maximiser',
    close: 'Fermer',
    scrollToTop: 'Défiler vers le haut'
  },

  // Quiz Configuration
  quizConfiguration: {
    numberOfItems: 'Nombre d\'éléments',
    shuffleQuestions: 'Mélanger les questions',
    randomizeQuestionOrder: 'Randomiser l\'ordre des questions',
    quizQuestions: 'Questions du quiz',
    addSampleQuestions: 'Ajouter des questions d\'exemple',
    clearAll: 'Tout effacer',
    confirmRemoveAllQuestions: 'Êtes-vous sûr de vouloir supprimer toutes les questions ?',
    question: 'Question',
    moveUp: 'Monter',
    moveDown: 'Descendre',
    deleteQuestion: 'Supprimer la question',
    questionPrompt: 'Question',
    enterQuestionPrompt: 'Entrer la question',
    correctAnswer: 'Réponse correcte',
    enterCorrectAnswer: 'Entrer la réponse correcte',
    answerChoices: 'Choix de réponses (séparés par des virgules)',
    choicesPlaceholder: '1, 2, 3, 4, 5',
    choices: 'choix',
    countObjects: 'Compter les objets',
    addChoice: 'Ajouter un choix',
    removeChoice: 'Supprimer un choix',
    answerNotInChoices: 'Réponse non dans les choix !',
    interactiveResource: 'Ressource interactive',
    resourceType: 'Type de ressource',
    objectsCount: 'Nombre d\'objets',
    layout: 'Disposition',
    randomClustered: 'Aléatoire groupé',
    twoGroups: 'Deux groupes',
    linear: 'Linéaire',
    randomize: 'Aléatoire',
    randomizeObjectPositions: 'Aléatoire les positions des objets',
    frameValue: 'Valeur du cadre',
    rows: 'Lignes',
    columns: 'Colonnes',
    minValue: 'Valeur minimale',
    maxValue: 'Valeur maximale',
    tickEvery: 'Toutes les',
    markPosition: 'Marquer la position',
    bank: 'Banque (séparés par des virgules)',
    bankPlaceholder: '0, 1, 2, 3, 4, 5',
    mode: 'Mode',
    readAndSelect: 'Lire et sélectionner',
    dragAndDrop: 'Glisser-déposer',
    clickToFill: 'Cliquer pour remplir',
    autoFlip: 'Retourner automatiquement',
    cards: 'Cartes (séparées par des virgules)',
    cardsPlaceholder: 'A, B, C, D, E',
    autoFlipCards: 'Retourner automatiquement les cartes',
    addResource: 'Ajouter une ressource',
    removeResource: 'Supprimer la ressource',
    addQuestion: 'Ajouter une question',
    addNewQuestion: 'Ajouter une nouvelle question',
    includeInteractiveResource: 'Inclure une ressource interactive',
    addInteractiveComponent: 'Ajouter un composant interactif (ex: compter les objets)',
    quickAdd: 'Ajout rapide',
    enterChoices: 'Entrer les choix (séparés par des virgules)',
    correctAnswerMustBeOneOfTheChoices: 'La réponse correcte doit être l\'un des choix',
    howManyObjectsDoYouSee: 'Combien d\'objets voyez-vous ?',
    whatNumberComesAfter9: 'Quel nombre vient après 9 ?',
    whatIs5Plus3: 'Qu\'est-ce que 5 + 3 ?'
  },

  // Number Line Component
  numberLine: {
    numberLine: 'Ligne numérique',
    current: 'Actuel',
    range: 'Plage',
    zoom: 'Zoom',
    showingEvery: 'affichage de tous les',
    number: 'nombre',
    numbers: 'nombres'
  },

  // Ten Frame Component
  tenFrame: {
    tenFrame: 'Cadre de dix',
    count: 'Compte',
    preset: 'Préréglage'
  },

  // Count Objects Component
  countObjects: {
    countObjects: 'Compter les objets',
    counted: 'Compté'
  },

  // Audio Bank Component
  audioBank: {
    audioBank: 'Banque audio',
    wordsAvailable: 'mots disponibles',
    playing: 'Lecture...',
    clickToPlay: 'Cliquer pour jouer',
    playAll: 'Tout jouer',
    stop: 'Arrêter',
    clear: 'Effacer',
    speechSynthesisNotSupported: 'La synthèse vocale n\'est pas prise en charge dans ce navigateur. La lecture audio ne fonctionnera pas.'
  },

  // Simulation Component
  simulation: {
    virtualLabSimulation: 'Simulation de laboratoire virtuel',
    interactiveScienceExperiment: 'Expérience scientifique interactive',
    experimentComponents: 'Composants d\'expérience',
    experimentInProgress: 'Expérience en cours...',
    temperature: 'Température',
    humidity: 'Humidité',
    waterLevel: 'Niveau d\'eau',
    startExperiment: 'Démarrer l\'expérience',
    nextStep: 'Étape suivante',
    reset: 'Réinitialiser'
  },

  // Interactive Diagram Component
  interactiveDiagram: {
    interactiveDiagram: 'Diagramme interactif',
    clickOnStagesToLearnMore: 'Cliquer sur les étapes pour en savoir plus'
  },

  // Quiz Component
  quiz: {
    quizResults: 'Résultats du quiz',
    correct: 'Correct',
    perfectScore: 'Score parfait !',
    keepPracticing: 'Continuez à pratiquer !',
    quickQuiz: 'Quiz rapide',
    question: 'Question',
    of: 'sur'
  },

  // Tracking Dashboard Page
  trackingDashboardPage: {
    trackingDashboard: 'Tableau de bord de suivi',
    monitorStudentEngagement: 'Surveiller l\'engagement des étudiants et l\'analyse d\'apprentissage',
    filters: 'Filtres',
    refreshData: 'Actualiser les données',
    lesson: 'Leçon',
    selectALesson: 'Sélectionner une leçon',
    untitledLesson: 'Leçon sans titre',
    startDate: 'Date de début',
    endDate: 'Date de fin',
    noLessonSelected: 'Aucune leçon sélectionnée',
    selectLessonToViewData: 'Sélectionnez une leçon dans les filtres ci-dessus pour afficher les données de suivi',
    lessonId: 'ID de la leçon',
    export: 'Exporter',
    exporting: 'Exportation...',
    clearData: 'Effacer les données',
    confirmClearData: 'Êtes-vous sûr de vouloir effacer toutes les données de suivi pour cette leçon ? Cette action ne peut pas être annulée.',
    totalStudents: 'Total des étudiants',
    averageTime: 'Temps moyen',
    averageScore: 'Score moyen',
    completionRate: 'Taux d\'achèvement',
    recentEvents: 'Événements récents',
    loadingEvents: 'Chargement des événements...',
    noEventsFound: 'Aucun événement trouvé pour la plage de dates sélectionnée',
    student: 'Étudiant',
    unknownTime: 'Heure inconnue',
    invalidTime: 'Heure invalide',
    dataPoints: 'points de données',
    trackingDisabled: 'Suivi désactivé',
    enableTrackingMessage: 'Activez le suivi dans les paramètres de la leçon pour collecter les données des étudiants',
    loading: 'Chargement...',
    noLessonsAvailable: 'Aucune leçon disponible',
    createLessonsToTrack: 'Créez des leçons pour commencer à suivre l\'engagement des élèves',
    searchLessons: 'Rechercher des leçons...',
    noLessonsFound: 'Aucune leçon trouvée correspondant à votre recherche'
  },

  // Lesson Session
  lessonSession: {
    lessonCompleted: 'Leçon terminée ! Excellent travail !',
    loadingLesson: 'Chargement de la leçon...',
    hideResources: 'Masquer les ressources',
    showResources: 'Afficher les ressources',
    resources: 'Ressources',
    teacherScript: 'Script de l\'enseignant',
    studentActions: 'Actions des élèves',
    checksForUnderstanding: 'Vérifications de compréhension',
    lookFor: 'Rechercher',
    commonError: 'Erreur commune',
    sessionControls: 'Contrôles de session',
    finish: 'Terminer',
    step: 'Étape',
    of: 'sur',
    lessonInformation: 'Informations sur la leçon',
    duration: 'Durée',
    minutes: 'minutes',
    objectives: 'Objectifs',
    digitalMaterials: 'Matériaux numériques',
    physicalMaterials: 'Matériaux physiques',
    availableAssessments: 'Évaluations disponibles',
    questions: 'questions',
    studentSelected: 'Élève sélectionné',
    selectStudent: 'Sélectionner un élève',
    clearStudentSelection: 'Effacer la sélection d\'élève'
  },

  // Student Selector
  studentSelector: {
    currentStudent: 'Élève actuel',
    noStudentSelected: 'Aucun élève sélectionné',
    students: 'Élèves',
    addStudent: 'Ajouter un élève',
    editStudent: 'Modifier l\'élève',
    deleteStudent: 'Supprimer l\'élève',
    updateStudent: 'Mettre à jour l\'élève',
    addNewStudent: 'Ajouter un nouvel élève',
    name: 'Nom',
    grade: 'Niveau',
    class: 'Classe',
    enterName: 'Entrer le nom de l\'élève',
    enterGrade: 'Entrer le niveau',
    enterClass: 'Entrer la classe',
    cancel: 'Annuler',
    clearSelection: 'Effacer la sélection',
    noStudents: 'Aucun élève disponible',
    noSearchResults: 'Aucun élève ne correspond à votre recherche',
    confirmDelete: 'Êtes-vous sûr de vouloir supprimer cet élève ?',
    importStudents: 'Importer des Élèves',
    exportStudents: 'Exporter des Élèves',
    import: 'Importer',
    export: 'Exporter',
    importDescription: 'Téléchargez un fichier JSON contenant un tableau d\'élèves. Chaque élève doit avoir un nom, et optionnellement un niveau et une classe.',
    fileFormat: 'Format de Fichier',
    selectFile: 'Sélectionner un Fichier JSON',
    importing: 'Importation...',
    searchStudents: 'Rechercher des élèves...',
    lessonFilterActive: 'Filtre de Leçon Actif'
  },

  // Admin
  admin: {
    lessonManagement: 'Gestion des Leçons',
    manageAllLessons: 'Gérer toutes les leçons du système',
    createAdminLesson: 'Créer une Leçon d\'Administrateur',
    totalLessons: 'Total des Leçons',
    adminLessons: 'Leçons d\'Administrateur',
    teacherLessons: 'Leçons d\'Enseignant',
    searchLessons: 'Rechercher des leçons...',
    allLessons: 'Toutes les Leçons',
    showingResults: 'Affichage de {count} sur {total} leçons',
    loadingLessons: 'Chargement des leçons...',
    noLessonsFound: 'Aucune leçon trouvée',
    noLessonsMatchFilters: 'Aucune leçon ne correspond à vos filtres actuels',
    adminLesson: 'Leçon d\'Administrateur',
    teacherLesson: 'Leçon d\'Enseignant',
    viewLesson: 'Voir la Leçon',
    editLesson: 'Modifier la Leçon',
    deleteLesson: 'Supprimer la Leçon',
    confirmDeleteLesson: 'Êtes-vous sûr de vouloir supprimer cette leçon ? Cette action ne peut pas être annulée.',
    lessonDeleted: 'Leçon supprimée avec succès',
    deleteError: 'Erreur lors de la suppression de la leçon',
    accessDenied: 'Accès Refusé',
    adminPrivilegesRequired: 'Les privilèges d\'administrateur sont requis pour accéder à cette page.',
    lessonDuplicated: 'Leçon dupliquée avec succès',
    duplicateError: 'Erreur lors de la duplication de la leçon',
    lessonMarkedAsAdmin: 'Leçon marquée comme admin',
    lessonUnmarkedAsAdmin: 'Leçon démarrée comme admin',
    markAsAdmin: 'Marquer comme admin',
    unmarkAsAdmin: 'Démarquer comme admin',
    duplicateLesson: 'Dupliquer la leçon',
    oldest: 'Anciennes en premier',
    bySubject: 'Par matière'
  },

  // Students
  common: {
    cancel: 'Annuler',
    save: 'Enregistrer'
  },
  students: {
    management: 'Gestion des Élèves',
    manageStudents: 'Gérez vos élèves et leurs relations',
    addStudent: 'Ajouter un Élève',
    editStudent: 'Modifier l\'Élève',
    deleteStudent: 'Supprimer l\'Élève',
    totalStudents: 'Total des Élèves',
    assignedToClass: 'Assignés à une Classe',
    activeStudents: 'Élèves Actifs',
    totalClasses: 'Total des Classes',
    searchStudents: 'Rechercher des élèves...',
    allClasses: 'Toutes les Classes',
    allSchoolYears: 'Toutes les Années Scolaires',
    showingResults: 'Affichage de {count} sur {total} élèves',
    loading: 'Chargement des élèves...',
    noStudentsFound: 'Aucun élève trouvé',
    noStudentsMatchFilters: 'Aucun élève ne correspond à vos filtres actuels',
    grade: 'Niveau',
    class: 'Classe',
    schoolYear: 'Année Scolaire',
    noGrade: 'Aucun niveau assigné',
    noClass: 'Aucune classe assignée',
    noSchoolYear: 'Aucune année scolaire assignée',
    name: 'Nom',
    unknownClass: 'Classe inconnue',
    status: {
      active: 'Actif',
      inactive: 'Inactif',
      transferred: 'Transféré'
    },
    addSuccess: 'Élève ajouté avec succès',
    addError: 'Erreur lors de l\'ajout de l\'élève',
    updateSuccess: 'Élève mis à jour avec succès',
    updateError: 'Erreur lors de la mise à jour de l\'élève',
    deleteSuccess: 'Élève supprimé avec succès',
    deleteError: 'Erreur lors de la suppression de l\'élève',
    confirmDelete: 'Êtes-vous sûr de vouloir supprimer cet élève ? Cette action ne peut pas être annulée.',
    assignClassSuccess: 'Élève assigné à la classe avec succès',
    assignClassError: 'Erreur lors de l\'assignation de l\'élève à la classe',
    removeClassSuccess: 'Élève retiré de la classe avec succès',
    removeClassError: 'Erreur lors du retrait de l\'élève de la classe',
    loadError: 'Erreur lors du chargement des élèves',
    notes: 'Notes',
    statusText: 'Statut',
    importStudents: 'Importer des Élèves',
    importInstructions: 'Téléchargez un fichier CSV ou collez les données CSV ci-dessous',
    csvData: 'Données CSV',
    preview: 'Aperçu',
    rows: 'lignes',
    importFormat: 'Format d\'Import',
    required: 'Requis',
    optional: 'Optionnel',
    downloadTemplate: 'Télécharger le Modèle',
    importing: 'Importation...',
    importSuccess: 'Importation réussie de {count} élèves',
    importError: 'Erreur lors de l\'importation des élèves',
    importErrorNoData: 'Aucune donnée fournie pour l\'importation',
    importErrorNoValidData: 'Aucune donnée d\'élève valide trouvée',
    importErrorNoStudentsImported: 'Aucun élève n\'a été importé',
    importErrorInvalidFormat: 'Format CSV invalide. Assurez-vous que le fichier a une ligne d\'en-tête et au moins une ligne de données.',
    importErrorMissingNameColumn: 'Le CSV doit contenir une colonne "Nom". Veuillez vérifier le format de votre fichier.',
    searchSchoolYear: 'Rechercher l\'année scolaire...',
    searchClass: 'Rechercher la classe...',
    saving: 'Enregistrement...'
  },

  // Pattern Maker Component
  patternMaker: {
    name: 'Créateur de Rythmes',
    description: 'Créateur de rythmes et séries pour les exercices de sériation',
    question: 'Question ou consigne',
    pattern: 'Rythme à reproduire',
    options: 'Éléments disponibles',
    allowInteraction: 'Permettre l\'interaction',
    showHint: 'Afficher les astuces',
    maxLength: 'Longueur maximale',
    addPatternItem: 'Ajouter au rythme',
    addOptionItem: 'Ajouter aux options',
    removeItem: 'Supprimer l\'élément',
    playPattern: 'Voir le modèle',
    validatePattern: 'Valider le rythme',
    resetPattern: 'Recommencer',
    patternCompleted: 'Rythme terminé',
    patternIncorrect: 'Rythme incorrect',
    continuePattern: 'Continuez le rythme',
    elementsPlaced: 'Éléments placés',
    patternsCompleted: 'Rythmes réussis',
    removeLastElement: 'Supprimer le dernier élément',
    availableElements: 'Éléments disponibles',
    yourPattern: 'Votre rythme',
    modelPattern: 'Modèle à reproduire',
    quickPatterns: 'Rythmes rapides',
    redBlue: 'Rouge-Bleu',
    stars: 'Étoiles',
    fruits: 'Fruits',
    colors: 'Couleurs',
    quickOptions: 'Options rapides',
    perfect: 'Parfait ! Vous avez reproduit le rythme correctement !',
    good: 'Bien ! Continuez !',
    tryAgain: 'Essayez encore !',
    startPlacing: 'Commencez par placer un élément !',
    continue: 'Continuez ! Il manque des éléments.',
    allElementsPlaced: 'Tous les éléments sont placés ! Cliquez sur "Valider" pour vérifier.',
    noElementsPlaced: 'Aucun élément placé pour valider',
    tip: 'Astuce : Regardez le modèle et reproduisez le même rythme !'
  },

  // Shape Recognition Component
  shapeRecognition: {
    name: 'Reconnaissance des Formes',
    description: 'Activité interactive pour reconnaître et nommer les formes géométriques',
    instructions: 'Instructions',
    shapes: 'Formes',
    shapeName: 'Nom de la forme',
    shapeDescription: 'Description',
    properties: 'Propriétés',
    addShape: 'Ajouter une forme',
    removeShape: 'Supprimer la forme',
    addProperty: 'Ajouter une propriété',
    removeProperty: 'Supprimer la propriété',
    showHints: 'Afficher les indices',
    allowCorrections: 'Permettre les corrections',
    difficultyLevel: 'Niveau de difficulté',
    easy: 'Facile',
    medium: 'Moyen',
    hard: 'Difficile',
    whatShape: 'Comment s\'appelle cette forme ?',
    validate: 'Valider',
    showAnswer: 'Voir la réponse',
    nextShape: 'Forme suivante',
    restart: 'Recommencer',
    congratulations: 'Félicitations !',
    allShapesRecognized: 'Vous avez reconnu toutes les formes !',
    progress: 'Progression',
    shapesRecognized: 'formes reconnues',
    correct: 'Bravo ! C\'est bien un {shapeName} !',
    incorrect: 'Ce n\'est pas tout à fait ça. Essayez encore !',
    hint: 'C\'est un {shapeName} !',
    allShapes: 'Toutes les formes',
    commonShapes: 'Formes communes',
    circle: 'Cercle',
    square: 'Carré',
    triangle: 'Triangle',
    rectangle: 'Rectangle',
    diamond: 'Losange',
    star: 'Étoile',
    hexagon: 'Hexagone',
    pentagon: 'Pentagone'
  },

  // Sorting Game Component
  sortingGame: {
    sortingGame: 'Jeu de Tri',
    sortItemsIntoCategories: 'Classez les éléments dans les bonnes catégories',
    dragItemsToCategories: 'Glissez les éléments vers les catégories',
    startGame: 'Commencer le jeu',
    resetGame: 'Recommencer',
    validateSorting: 'Valider le tri',
    gameCompleted: 'Jeu terminé !',
    correctPlacement: 'Placement correct !',
    incorrectPlacement: 'Placement incorrect',
    tryAgain: 'Essayez encore',
    itemsSorted: 'Éléments triés',
    sortedItems: 'Éléments triés',
    totalItems: 'Total',
    status: 'Statut',
    completed: 'Terminé',
    inProgress: 'En cours',
    sortingCriteria: 'Critère de tri',
    byCategory: 'Par catégorie',
    byColor: 'Par couleur',
    bySize: 'Par taille',
    changeCriteria: 'Changer le critère',
    validationResults: 'Résultats de validation',
    correctItems: 'Éléments corrects',
    correct: 'Correct',
    incorrectItems: 'Éléments incorrects',
    incorrect: 'Incorrect',
    accuracy: 'Précision',
    wellDone: 'Bien joué !',
    keepTrying: 'Continuez !',
    perfectScore: 'Score parfait !',
    goodJob: 'Bon travail !',
    almostThere: 'Presque !',
    hints: 'Indices',
    showHints: 'Afficher les indices',
    hideHints: 'Masquer les indices'
  },

  // Export Dropdown
  export: {
    dropdown: {
      button: 'Exporter',
      tooltip: 'Exporter la leçon',
      exporting: 'Exportation en cours...'
    },
    options: {
      title: 'Options d\'export',
      includeResources: 'Inclure les ressources',
      includeAssessments: 'Inclure les évaluations',
      includeNotes: 'Inclure les notes',
      cancel: 'Annuler',
      confirm: 'Exporter',
      exporting: 'Exportation...'
    }
  },

  // Export PowerPoint
  exportPowerPoint: {
    button: 'Exporter vers PowerPoint',
    exporting: 'Exportation en cours...',
    tooltip: 'Exporter la leçon vers PowerPoint',
    success: 'Leçon exportée avec succès !',
    error: {
      noLesson: 'Aucune donnée de leçon disponible',
      exportFailed: 'Échec de l\'exportation de la leçon'
    }
  },

  exportWord: {
    button: 'Exporter vers Word',
    exporting: 'Exportation en cours...',
    tooltip: 'Exporter la leçon vers Word',
    success: 'Leçon exportée avec succès !',
    error: {
      noLesson: 'Aucune donnée de leçon disponible',
      exportFailed: 'Échec de l\'exportation de la leçon'
    }
  }
};
